import React, { useState, useRef, useEffect } from "react";
import { TokenVerificationLoggedin, BlockAdmin } from "../../utils/tokenVerify";
import DateRangePicker from 'react-bootstrap-daterangepicker';
import moment from 'moment';
import axios from "axios";
import Cookies from "js-cookie";
import configData from "../../config/config.json";
import RangeCalendar from '../../assets/images/icons/range-calendar.svg';
import { useLocation } from "react-router-dom";
import { Input, Button, Table, Row, Col, Pagination, Select, Tooltip, Checkbox, Modal } from 'antd';
// import { DownOutlined, UpOutlined, RightOutlined } from "@ant-design/icons";
// import { CloseOutlined } from "@ant-design/icons";
import Dropdown from 'react-bootstrap/Dropdown';
import { saveAs } from "file-saver";
import FullLoader from "../../assets/images/full-page-loader.gif"
// import infoIcon from '../../assets/images/icons/info.svg';
// import mediaKitIcon from '../../assets/images/icons/export_download_icon.svg';
import { jwtDecode } from "jwt-decode";
import { notifyfailure, notifysuccess, notifycatch } from "../../utils/toast";
import prevIcon from '../../assets/images/icons/chevron-left.svg';
import nextIcon from '../../assets/images/icons/chevron-right.svg';
import TableLoader from "../TableLoader";
import noData from '../../assets/images/data-graph/no-data.svg';
import error2Data from '../../assets/images/data-graph/error2-data.svg';
import errorData from '../../assets/images/data-graph/error-data.svg';
import { Link } from 'react-router-dom'
import filterIcon from '../../assets/images/icons/filter.svg';
import dimensionIcon from '../../assets/images/icons/filter_dimension_icon.svg';
import metricIcon from '../../assets/images/icons/filter_metric_icon.svg';
import * as XLSX from "xlsx";
// import { CSVLink } from "react-csv";
import reportInfo from '../../assets/images/icons/report_info.svg';
import partialDataIcon from '../../assets/images/icons/parital_data_icon.svg';
import timeDataIcon from '../../assets/images/icons/time_data_icon.svg';
import addIcon from '../../assets/images/addbtnicon/plusicon.svg';
import removeIcon from '../../assets/images/icons/minus_circle_remove_ icon.svg';
import selectPlusIcon from '../../assets/images/icons/select_plus_icon.svg';
import { SearchOutlined } from '@ant-design/icons';
import ConstantMapping from './ReportMapping.json';
import loaderIcon from "../../assets/images/login-and-signup/loader.gif";
import uploadFileIcon from '../../assets/images/icons/upload_file_icon.svg';
import { TreeSelect } from "antd";
const { SHOW_PARENT } = TreeSelect;

const { Option } = Select;

const Reporting = () => {

    const savedReportFromListing = new URLSearchParams(useLocation().search).get("savedReport");
    const [pageLoad, setPageLoad] = useState(true)

    const [columnsAll, setColumnsAll] = useState([])
    const [exportHeader, setExportHeader] = useState([])

    const [errorScreen, setErrorScreen] = useState(false)
    const [data, setData] = useState([])
    const [exportData, setExportData] = useState([])
    const [totalData, setTotalData] = useState([])
    const [total, setTotal] = useState({})
    const [loading, setLoading] = useState(true)
    const [backendLoading, setBackendLoading] = useState(false)
    const [initialLoad, setInitialLoad] = useState(true)

    const [paginationProcess, setPaginationProcess] = useState("frontend")
    const [totalAdkRecords, setTotalAdkRecords] = useState(0)
    const [exportBackendLoading, setExportBackendLoading] = useState(false)
    const [page, setPage] = useState({
        current: 1,
        pageSize: 500,
        total: 0,
    });
    const [sortObject, setSortObject] = useState({
        name: "",
        type: ""
    });

    const [search, setSearch] = useState("")


    useEffect(() => {
        TokenVerificationLoggedin();
        BlockAdmin()

        if (savedReportFromListing) {
            // {
            //     "_id": "67ada25cfaa2ad2b5fc79d64",
            //     "name": "GG_Test_Anyclip_t1",
            //     "date": "2025-02-7 - 2025-03-18",
            //     "dateLabel": "Custom Range",
            //     "dateTimeStamp": { "start": "2025-03-10T12:41:31.288Z", "end": "2025-03-10T12:41:31.288Z" },
            //     "dimensions": [
            //         "Publisher",
            //         "Traffic Type",
            //         "Format Type",
            //         "Country"
            //     ],
            //     "metrics": [
            //         "Net Viewability (%)",
            //         "Discrepancies",
            //         "SIVT Ad Count",
            //         "Gross CPM (%)"
            //     ],
            //     "filters": [
            //         "Publisher",
            //         "Platform",
            //         "Zone",
            //         "Platform 2"
            //     ],

            //     "createdAt": "2025-02-13",
            // },
            // setMetricsList(["remotefeed_requests", "pub_response"])
            // setDimensionsList(["publisher", "zone"])

            // setDateRange({
            //     start: moment("2025-02-05T18:30:00.000Z"),
            //     end: moment("2025-02-21T18:29:59.999Z")
            // });
            // setPageLoad(false)

            // getDataSavedReport({
            //     start: moment("2025-02-05T18:30:00.000Z"),
            //     end: moment("2025-02-21T18:29:59.999Z")
            // }, ["publisher", "zone"], ["remotefeed_requests", "pub_response"], [])


            // const [dateRange, setDateRange] = useState({
            //     start: moment().subtract(1, 'days'),
            //     end: moment().subtract(1, 'days'),
            // });

            // const [dateRange, setDateRange] = useState({
            //     start: moment("2025-02-05T18:30:00.000Z"),
            //     end: moment("2025-02-21T18:29:59.999Z")
            // });
            setPageLoad(false)
        }
        else {
            setPageLoad(false)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    function addCommasToNumber(num) {
        const isDecimal = num % 1 !== 0;
        let numStr = num.toString();
        let [wholePart, decimalPart] = numStr.split(".");
        wholePart = wholePart.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        if (isDecimal) {
            numStr = `${wholePart}.${decimalPart}`;
        } else {
            numStr = wholePart;
        }

        return numStr;
    }

    function paginateArray(data, pageNo, limit, searchKey = "", sortKey = "", sortOrder = "") {

        let tempPage = page

        if (!Array.isArray(data) || data.length === 0) {
            setData([]);
            tempPage.total = 0
            setPage(tempPage);
            return;
        }
        else {
            const filteredData = searchKey
                ? data.filter(
                    (item) =>
                        item.publisher_id?.toString().toLowerCase().includes(searchKey.toLowerCase()) ||
                        item.publisher?.toLowerCase().includes(searchKey.toLowerCase()) ||
                        item.zone_id?.toString().toLowerCase().includes(searchKey.toLowerCase()) ||
                        item.zone?.toLowerCase().includes(searchKey.toLowerCase()) ||
                        item.country?.toLowerCase().includes(searchKey.toLowerCase()) ||
                        item.traffic_type?.toLowerCase().includes(searchKey.toLowerCase()) ||
                        item.site_domain?.toLowerCase().includes(searchKey.toLowerCase()) ||
                        item.app_bundle?.toLowerCase().includes(searchKey.toLowerCase())
                )
                : data;

            let sortedData;

            if (sortOrder !== "") {
                sortedData = sortKey
                    ? [...filteredData].sort((a, b) => {
                        const aValue = a[sortKey] ?? "";
                        const bValue = b[sortKey] ?? "";

                        if (typeof aValue === "string" && typeof bValue === "string") {
                            return aValue.localeCompare(bValue) * sortOrder;
                        }
                        return (aValue - bValue) * sortOrder;
                    })
                    : filteredData;

            }
            else {
                sortedData = filteredData
            }

            const startIndex = (pageNo - 1) * limit;
            const endIndex = startIndex + limit;
            const paginatedData = sortedData.slice(startIndex, endIndex);

            tempPage.current = pageNo
            if (paginationProcess === "backend" && search === "") {
                tempPage.total = totalAdkRecords
            }
            else {
                tempPage.total = sortedData.length
            }

            setPage(tempPage);

            setData(paginatedData);

        }
    }

    function paginateArrayFrontendCall(data, pageNo, limit, searchKey = "", sortKey = "", sortOrder = "") {

        let tempPage = page

        if (!Array.isArray(data) || data.length === 0) {
            setData([]);
            tempPage.total = 0
            setPage(tempPage);
            return;
        }
        else {
            const filteredData = searchKey
                ? data.filter(
                    (item) =>
                        item.publisher_id?.toString().toLowerCase().includes(searchKey.toLowerCase()) ||
                        item.publisher?.toLowerCase().includes(searchKey.toLowerCase()) ||
                        item.zone_id?.toString().toLowerCase().includes(searchKey.toLowerCase()) ||
                        item.zone?.toLowerCase().includes(searchKey.toLowerCase()) ||
                        item.country?.toLowerCase().includes(searchKey.toLowerCase()) ||
                        item.traffic_type?.toLowerCase().includes(searchKey.toLowerCase()) ||
                        item.site_domain?.toLowerCase().includes(searchKey.toLowerCase()) ||
                        item.app_bundle?.toLowerCase().includes(searchKey.toLowerCase())
                )
                : data;

            let sortedData;

            if (sortOrder !== "") {
                sortedData = sortKey
                    ? [...filteredData].sort((a, b) => {
                        const aValue = a[sortKey] ?? "";
                        const bValue = b[sortKey] ?? "";

                        if (typeof aValue === "string" && typeof bValue === "string") {
                            return aValue.localeCompare(bValue) * sortOrder;
                        }
                        return (aValue - bValue) * sortOrder;
                    })
                    : filteredData;

            }
            else {
                sortedData = filteredData
            }

            const startIndex = (pageNo - 1) * limit;
            const endIndex = startIndex + limit;
            const paginatedData = sortedData.slice(startIndex, endIndex);

            tempPage.current = pageNo
            tempPage.pageSize = limit
            tempPage.total = sortedData.length

            setPage(tempPage);

            setData(paginatedData);

        }
    }

    const tableScrollRef = useRef(null);
    const scrollToItem = (ref, offset = 80) => {
        if (ref && ref.current) {
            ref.current.style.scrollMarginTop = `${offset}px`;
            ref.current.scrollIntoView({ behavior: "smooth", block: "start" });
            setTimeout(() => {
                ref.current.style.scrollMarginTop = '';
            }, 500);
        }
    };

    // const getDataSavedReport = (dateApi, dimensionApi, metricApi, filterApi) => {
    //     setLoading(false)
    //     setInitialLoad(true)
    //     setData([])
    //     setTotalData([])
    //     setExportData([])
    //     setTotal([])
    //     setSortObject({
    //         name: "",
    //         type: ""
    //     })

    //     let status = Cookies.get("token_xapads_ssp") ? true : false;
    //     if (status) {

    //         let token = Cookies.get("token_xapads_ssp");

    //         let dataFor = 0;
    //         let publisher_ids = [];
    //         let zone_ids = []

    //         let dateRangeCall = {
    //             startDate: dateRange?.start.format('YYYY-MM-DD'),
    //             endDate: dateRange?.end.format('YYYY-MM-DD')
    //         };

    //         if (filterRepeater.length > 0) {
    //             for (let i = 0; i < filterRepeater.length; i++) {
    //                 if (filterRepeater[i]["label"] === "platform") {
    //                     if (filterRepeater[i]["value"].length === 1) {
    //                         dataFor = filterRepeater[i]["value"]
    //                     }
    //                 }

    //                 if (filterRepeater[i]["label"] === "publisher") {
    //                     publisher_ids = filterRepeater[i]["value"]
    //                 }

    //                 if (filterRepeater[i]["label"] === "zone") {
    //                     zone_ids = filterRepeater[i]["value"]
    //                 }
    //             }
    //         }


    //         axios.post(configData.SERVER_URL + `report/`, {
    //             "filter": { "dataFor": dataFor, "dimensions": dimensionApi !== undefined ? dimensionApi : dimensionsList, metrics: metricApi !== undefined ? metricApi : metricsList, "publisher_ids": publisher_ids, "zone_ids": zone_ids },
    //             "date": dateRangeCall,
    //         }, {
    //             headers: {
    //                 "Content-Type": "application/json",
    //                 "x-access-token": token,
    //             },
    //         })
    //             .then((response) => {


    //                 if (response.data.data && response.data.data.length > 0) {

    //                     let tempPage = { ...page }
    //                     tempPage.current = 1
    //                     tempPage.total = response.data.totalRecords
    //                     setPage(tempPage)

    //                     setTotalData(response.data.data)
    //                     setTotal(response.data.total)
    //                     paginateArray(response.data.data, 1, tempPage.pageSize, search, "", "")

    //                     //export Logic
    //                     let tempData = [...response.data.data];
    //                     let tempTotal = { ...response.data.total }; // Spread existing properties
    //                     let totalKey = ConstantMapping.Get_Dimensions_Set[dimensionsList[0]][0]
    //                     tempTotal[totalKey] = "Total";
    //                     tempData.push(tempTotal); // Append the updated object to the array
    //                     setExportData(tempData);
    //                     setErrorScreen(false)

    //                 }
    //                 else {
    //                     let tempPage = { ...page }
    //                     tempPage.current = 1
    //                     tempPage.total = 0
    //                     setPage(tempPage)
    //                     setTotalData([])
    //                     setTotal([])
    //                     setData([])
    //                     setExportData([])
    //                     setErrorScreen(false)
    //                 }


    //                 let updatedColumns = []
    //                 let updatedExportColumns = []
    //                 let fixedColumnCount = 0;
    //                 for (let i = 0; i < dimensionsList.length; i++) {

    //                     const values = ConstantMapping.Get_Dimensions_Set[dimensionsList[i]]

    //                     if (values !== undefined) {
    //                         for (let i = 0; i < values.length; i++) {
    //                             updatedColumns.push(provideDynamicHeaderColumns(values[i], fixedColumnCount, false, ""))
    //                             updatedExportColumns.push(provideDynamicExportColumns(values[i], ""))

    //                         }

    //                         fixedColumnCount++;
    //                     }
    //                 }

    //                 for (let i = 0; i < metricsList.length; i++) {
    //                     updatedColumns.push(provideDynamicHeaderColumns(metricsList[i], "", response.data.data.length > 0 ? response.data.dataPartial : false, response.data.data.length > 0 ? response.data.pix_updatedAt : ""))
    //                     updatedExportColumns.push(provideDynamicExportColumns(metricsList[i], ""))
    //                 }

    //                 setColumnsAll(updatedColumns)
    //                 setExportHeader(updatedExportColumns)
    //                 setInitialLoad(false)

    //                 setTimeout(() => { scrollToItem(tableScrollRef) }, 1000)

    //             })
    //             .catch((error) => {

    //                 let updatedColumns = []
    //                 let updatedExportColumns = []
    //                 let fixedColumnCount = 0;
    //                 for (let i = 0; i < dimensionsList.length; i++) {

    //                     const values = ConstantMapping.Get_Dimensions_Set[dimensionsList[i]]

    //                     if (values !== undefined) {
    //                         for (let i = 0; i < values.length; i++) {
    //                             updatedColumns.push(provideDynamicHeaderColumns(values[i], fixedColumnCount, false, ""))
    //                             updatedExportColumns.push(provideDynamicExportColumns(values[i], ""))

    //                         }

    //                         fixedColumnCount++;
    //                     }
    //                 }

    //                 for (let i = 0; i < metricsList.length; i++) {
    //                     updatedColumns.push(provideDynamicHeaderColumns(metricsList[i], "", false, ""))
    //                     updatedExportColumns.push(provideDynamicExportColumns(metricsList[i], ""))
    //                 }

    //                 setColumnsAll(updatedColumns)
    //                 setExportHeader(updatedExportColumns)

    //                 setData([])
    //                 setTotalData([])
    //                 setExportData([])
    //                 setTotal([])
    //                 setInitialLoad(false)
    //                 setErrorScreen(true)

    //                 if (error?.response) {
    //                     if (error?.response?.data?.message?.length !== 0) {
    //                         notifyfailure(error.response.data.message)
    //                     }
    //                 } else {
    //                     notifycatch()
    //                 }
    //             });
    //     }

    // }

    const getDataViaFrontend = () => {
        setLoading(false)
        setInitialLoad(true)
        setData([])
        setTotalData([])
        setExportData([])
        setTotal([])
        setSortObject({
            name: "",
            type: ""
        })

        let status = Cookies.get("token_xapads_ssp") ? true : false;
        if (status) {

            let token = Cookies.get("token_xapads_ssp");

            let dataFor = 0;
            let publisher_ids = [];
            let zone_ids = []


            let dateRangeCall = {
                startDate: dateRange?.start.format('YYYY-MM-DD'),
                endDate: dateRange?.end.format('YYYY-MM-DD')
            };

            let metricsListForCall = metricsList.flatMap(item => item === "pixalate" ? ConstantMapping.Pixalate_related_keys : item)

            if (filterRepeater.length > 0) {
                for (let i = 0; i < filterRepeater.length; i++) {
                    if (filterRepeater[i]["label"] === "platform") {
                        if (filterRepeater[i]["value"].length === 1) {
                            dataFor = filterRepeater[i]["value"][0]
                        }
                    }

                    if (filterRepeater[i]["label"] === "publisher") {
                        publisher_ids = filterRepeater[i]["value"]
                    }

                    if (filterRepeater[i]["label"] === "zone") {
                        zone_ids = filterRepeater[i]["value"]
                    }
                }
            }


            axios.post(configData.SERVER_URL + `report/`, {
                "filter": { "dataFor": dataFor, "dimensions": dimensionsList, metrics: metricsListForCall, "publisher_ids": publisher_ids, "zone_ids": zone_ids },
                "date": dateRangeCall,
            }, {
                headers: {
                    "Content-Type": "application/json",
                    "x-access-token": token,
                },
            })
                .then((response) => {


                    if (response.data.data && response.data.data.length > 0) {

                        let tempPage = { ...page }
                        tempPage.current = 1
                        tempPage.total = response.data.totalRecords
                        setPage(tempPage)

                        setTotalData(response.data.data)
                        setTotal(response.data.total)
                        paginateArrayFrontendCall(response.data.data, 1, tempPage.pageSize, search, "", "")


                        //export Logic
                        let tempData = [...response.data.data];
                        let tempTotal = { ...response.data.total }; // Spread existing properties
                        let totalKey = ConstantMapping.Get_Dimensions_Set[dimensionsList[0]][0]
                        tempTotal[totalKey] = "Total";
                        tempData.push(tempTotal); // Append the updated object to the array
                        setExportData(tempData);
                        setErrorScreen(false)

                    }
                    else {
                        let tempPage = { ...page }
                        tempPage.current = 1
                        tempPage.total = 0
                        setPage(tempPage)
                        setTotalData([])
                        setTotal([])
                        setData([])
                        setExportData([])
                        setErrorScreen(false)
                    }


                    let updatedColumns1 = []
                    let updatedColumns2 = []
                    let updatedColumns3 = []
                    let updatedExportColumns1 = []
                    let updatedExportColumns2 = []
                    let updatedExportColumns3 = []
                    let fixedColumnCount = 0;


                    // ----------------------------------------
                    const priorityOrder = ["date", "publisher", "zone"];
                    const sortedDimensionsList = dimensionsList.sort((a, b) => {
                        const indexA = priorityOrder.indexOf(a);
                        const indexB = priorityOrder.indexOf(b);

                        if (indexA === -1 && indexB === -1) return 0;
                        if (indexA === -1) return 1;
                        if (indexB === -1) return -1;
                        return indexA - indexB;
                    });


                    //------------------------------------------

                    for (let i = 0; i < sortedDimensionsList.length; i++) {

                        const values = ConstantMapping.Get_Dimensions_Set[sortedDimensionsList[i]]

                        if (values !== undefined) {
                            for (let i = 0; i < values.length; i++) {
                                updatedColumns1.push(provideDynamicHeaderColumns(values[i], fixedColumnCount, false, "", ""))
                                updatedExportColumns1.push(provideDynamicExportColumns(values[i], ""))
                                fixedColumnCount++;
                            }


                        }
                    }

                    for (let i = 0; i < metricsListForCall.length; i++) {
                        if (
                            ConstantMapping.Pixalate_related_keys.includes(metricsListForCall[i])
                        ) {
                            updatedColumns3.push(provideDynamicHeaderColumns(metricsListForCall[i], "", response.data.data.length > 0 ? response.data.dataPartial : false, response.data.data.length > 0 ? response.data.pix_updatedAt : "", ""));

                            updatedExportColumns3.push(provideDynamicExportColumns(metricsListForCall[i], ""))

                        } else {
                            updatedColumns2.push(provideDynamicHeaderColumns(metricsListForCall[i], "", response.data.data.length > 0 ? response.data.dataPartial : false, response.data.data.length > 0 ? response.data.pix_updatedAt : "", ""));

                            updatedExportColumns2.push(provideDynamicExportColumns(metricsListForCall[i], ""))

                        }




                    }

                    setColumnsAll([
                        ...updatedColumns1,
                        ...updatedColumns2,
                        ...(updatedColumns3.length > 0
                            ? [
                                {
                                    title: "Pixalate",
                                    children: updatedColumns3,
                                },
                            ]
                            : []),
                    ])
                    setExportHeader([
                        ...updatedExportColumns1,
                        ...updatedExportColumns2,
                        ...updatedExportColumns3,
                    ])
                    setInitialLoad(false)

                    setTimeout(() => { scrollToItem(tableScrollRef) }, 1000)

                })
                .catch((error) => {

                    let updatedColumns1 = []
                    let updatedColumns2 = []
                    let updatedColumns3 = []
                    let updatedExportColumns1 = []
                    let updatedExportColumns2 = []
                    let updatedExportColumns3 = []
                    let fixedColumnCount = 0;

                    const priorityOrder = ["date", "publisher", "zone"];
                    const sortedDimensionsList = dimensionsList.sort((a, b) => {
                        const indexA = priorityOrder.indexOf(a);
                        const indexB = priorityOrder.indexOf(b);

                        if (indexA === -1 && indexB === -1) return 0; // Both are not in priority list, maintain order
                        if (indexA === -1) return 1; // A is not in priority list, B comes first
                        if (indexB === -1) return -1; // B is not in priority list, A comes first
                        return indexA - indexB; // Sort based on priority order
                    });


                    for (let i = 0; i < sortedDimensionsList.length; i++) {

                        const values = ConstantMapping.Get_Dimensions_Set[sortedDimensionsList[i]]

                        if (values !== undefined) {
                            for (let i = 0; i < values.length; i++) {
                                updatedColumns1.push(provideDynamicHeaderColumns(values[i], fixedColumnCount, false, "", ""))
                                updatedExportColumns1.push(provideDynamicExportColumns(values[i], ""))

                            }

                            fixedColumnCount++;
                        }
                    }

                    for (let i = 0; i < metricsListForCall.length; i++) {

                        if (
                            ConstantMapping.Pixalate_related_keys.includes(metricsListForCall[i])
                        ) {
                            updatedColumns3.push(provideDynamicHeaderColumns(metricsListForCall[i], "", false, "", ""));
                            updatedExportColumns3.push(provideDynamicExportColumns(metricsListForCall[i], ""))

                        } else {
                            updatedColumns2.push(provideDynamicHeaderColumns(metricsListForCall[i], "", false, "", ""));
                            updatedExportColumns2.push(provideDynamicExportColumns(metricsListForCall[i], ""))

                        }



                    }

                    setColumnsAll([
                        ...updatedColumns1,
                        ...updatedColumns2,
                        ...(updatedColumns3.length > 0
                            ? [
                                {
                                    title: "Pixalate",
                                    children: updatedColumns3,
                                },
                            ]
                            : []),
                    ])
                    setExportHeader([
                        ...updatedExportColumns1,
                        ...updatedExportColumns2,
                        ...updatedExportColumns3,
                    ])

                    setData([])
                    setTotalData([])
                    setExportData([])
                    setTotal([])
                    setInitialLoad(false)
                    setErrorScreen(true)

                    if (error?.response) {
                        if (error?.response?.data?.message?.length !== 0) {
                            notifyfailure(error.response.data.message)
                        }
                    } else {
                        notifycatch()
                    }
                });
        }

    }



    const handleExport = (columns, data) => {

        // Step 1: Build group header and column header rows
        const groupHeader = columns.map(col => col.group || "");
        const columnHeader = columns.map(col => col.label);

        // Step 2: Build data rows
        const dataRows = data.map(item =>
            columns.map(col => item[col.key] ?? "")
        );
        // Step 3: Combine into 2D array
        const sheetData = [groupHeader, columnHeader, ...dataRows];

        // Step 4: Create worksheet
        const worksheet = XLSX.utils.aoa_to_sheet(sheetData);

        // Step 5: Add merged cells for grouped headers
        worksheet["!merges"] = [];

        let colStart = 0;
        while (colStart < columns.length) {
            const group = columns[colStart].group;
            let colEnd = colStart;
            // Find how far the group extends
            while (
                colEnd + 1 < columns.length &&
                columns[colEnd + 1].group === group
            ) {
                colEnd++;
            }

            if (group && colEnd > colStart) {
                worksheet["!merges"].push({
                    s: { r: 0, c: colStart }, // start row 0
                    e: { r: 0, c: colEnd },   // end row 0
                });
            }

            colStart = colEnd + 1;
        }

        // Step 6: Create workbook & export as .xlsx
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Report");
        XLSX.writeFile(workbook, "Report_" + new Date().getTime() + ".xlsx");
    };


    const getDataViaBackend = (dateRange, dimensionsList, metricsList, filterRepeater, paginationReload, sortRelated, isExport) => {
        if (isExport !== 1) {
            setBackendLoading(true)
        }
        else {
            setExportBackendLoading(true)
        }



        let status = Cookies.get("token_xapads_ssp") ? true : false;
        if (status) {

            let token = Cookies.get("token_xapads_ssp");

            let dataFor = 0;
            let publisher_ids = [];
            let zone_ids = []

            let dateRangeCall = {
                startDate: dateRange?.start.format('YYYY-MM-DD'),
                endDate: dateRange?.end.format('YYYY-MM-DD')
            };

            let metricsListForCall = metricsList.flatMap(item => item === "pixalate" ? ConstantMapping.Pixalate_related_keys : item)

            if (filterRepeater.length > 0) {
                for (let i = 0; i < filterRepeater.length; i++) {
                    if (filterRepeater[i]["label"] === "platform") {
                        if (filterRepeater[i]["value"].length === 1) {
                            dataFor = filterRepeater[i]["value"][0]
                        }
                    }

                    if (filterRepeater[i]["label"] === "publisher") {
                        publisher_ids = filterRepeater[i]["value"]
                    }

                    if (filterRepeater[i]["label"] === "zone") {
                        zone_ids = filterRepeater[i]["value"]
                    }
                }
            }


            if (isExport !== 1) {
                axios.post(configData.SERVER_URL + `report/`, {
                    "filter": { "dataFor": dataFor, "dimensions": dimensionsList, metrics: metricsListForCall, "publisher_ids": publisher_ids, "zone_ids": zone_ids, "pagination": { "page": paginationReload === 1 ? 1 : page.current, "limit": page.pageSize }, "sort": { "field": sortRelated.name, "ord": sortRelated.type }, },

                    "date": dateRangeCall,
                }, {
                    headers: {
                        "Content-Type": "application/json",
                        "x-access-token": token,
                    },
                })
                    .then((response) => {




                        if (response.data.data && response.data.data.length > 0) {

                            let tempPage = { ...page }
                            if (paginationReload === 1) {
                                tempPage.current = 1
                            }
                            tempPage.total = response.data.adkTotalRecords
                            setTotalAdkRecords(response.data.adkTotalRecords)
                            setPage(tempPage)

                            setTotalData(response.data.data)
                            setTotal(response.data.total)
                            setData(response.data.data);

                            //export Logic
                            let tempData = [...response.data.data];
                            let tempTotal = { ...response.data.total }; // Spread existing properties
                            let totalKey = ConstantMapping.Get_Dimensions_Set[dimensionsList[0]][0]
                            tempTotal[totalKey] = "Total";
                            tempData.push(tempTotal); // Append the updated object to the array
                            setExportData(tempData);
                            setErrorScreen(false)

                        }
                        else {
                            let tempPage = { ...page }
                            tempPage.current = 1
                            tempPage.total = 0
                            setPage(tempPage)
                            setTotalData([])
                            setTotal([])
                            setData([])
                            setExportData([])
                            setErrorScreen(false)
                        }



                        let updatedColumns1 = []
                        let updatedColumns2 = []
                        let updatedColumns3 = []
                        let updatedExportColumns1 = []
                        let updatedExportColumns2 = []
                        let updatedExportColumns3 = []
                        let fixedColumnCount = 0;


                        // ----------------------------------------
                        const priorityOrder = ["date", "publisher", "zone"];
                        const sortedDimensionsList = dimensionsList.sort((a, b) => {
                            const indexA = priorityOrder.indexOf(a);
                            const indexB = priorityOrder.indexOf(b);

                            if (indexA === -1 && indexB === -1) return 0;
                            if (indexA === -1) return 1;
                            if (indexB === -1) return -1;
                            return indexA - indexB;
                        });


                        //------------------------------------------

                        for (let i = 0; i < sortedDimensionsList.length; i++) {

                            const values = ConstantMapping.Get_Dimensions_Set[sortedDimensionsList[i]]

                            if (values !== undefined) {
                                for (let i = 0; i < values.length; i++) {
                                    updatedColumns1.push(provideDynamicHeaderColumns(values[i], fixedColumnCount, false, "", "backend"))
                                    updatedExportColumns1.push(provideDynamicExportColumns(values[i], ""))
                                    fixedColumnCount++;
                                }


                            }
                        }

                        for (let i = 0; i < metricsListForCall.length; i++) {

                            if (
                                ConstantMapping.Pixalate_related_keys.includes(metricsListForCall[i])
                            ) {
                                updatedColumns3.push(provideDynamicHeaderColumns(metricsListForCall[i], "", response.data.data.length > 0 ? response.data.dataPartial : false, response.data.data.length > 0 ? response.data.pix_updatedAt : "", "backend"));

                                updatedExportColumns3.push(provideDynamicExportColumns(metricsListForCall[i], ""))
                            } else {
                                updatedColumns2.push(provideDynamicHeaderColumns(metricsListForCall[i], "", response.data.data.length > 0 ? response.data.dataPartial : false, response.data.data.length > 0 ? response.data.pix_updatedAt : "", "backend"));

                                updatedExportColumns2.push(provideDynamicExportColumns(metricsListForCall[i], ""))
                            }


                        }

                        setColumnsAll([
                            ...updatedColumns1,
                            ...updatedColumns2,
                            ...(updatedColumns3.length > 0
                                ? [
                                    {
                                        title: "Pixalate",
                                        children: updatedColumns3,
                                    },
                                ]
                                : []),
                        ])
                        setExportHeader([
                            ...updatedExportColumns1,
                            ...updatedExportColumns2,
                            ...updatedExportColumns3,
                        ])
                        setInitialLoad(false)
                        setBackendLoading(false)

                        setTimeout(() => { scrollToItem(tableScrollRef) }, 1000)

                    })
                    .catch((error) => {


                        let updatedColumns1 = []
                        let updatedColumns2 = []
                        let updatedColumns3 = []
                        let updatedExportColumns1 = []
                        let updatedExportColumns2 = []
                        let updatedExportColumns3 = []
                        let fixedColumnCount = 0;

                        const priorityOrder = ["date", "publisher", "zone"];
                        const sortedDimensionsList = dimensionsList.sort((a, b) => {
                            const indexA = priorityOrder.indexOf(a);
                            const indexB = priorityOrder.indexOf(b);

                            if (indexA === -1 && indexB === -1) return 0; // Both are not in priority list, maintain order
                            if (indexA === -1) return 1; // A is not in priority list, B comes first
                            if (indexB === -1) return -1; // B is not in priority list, A comes first
                            return indexA - indexB; // Sort based on priority order
                        });


                        for (let i = 0; i < sortedDimensionsList.length; i++) {

                            const values = ConstantMapping.Get_Dimensions_Set[sortedDimensionsList[i]]

                            if (values !== undefined) {
                                for (let i = 0; i < values.length; i++) {
                                    updatedColumns1.push(provideDynamicHeaderColumns(values[i], fixedColumnCount, false, "", "backend"))
                                    updatedExportColumns1.push(provideDynamicExportColumns(values[i], ""))

                                }

                                fixedColumnCount++;
                            }
                        }

                        for (let i = 0; i < metricsListForCall.length; i++) {
                            if (
                                ConstantMapping.Pixalate_related_keys.includes(metricsListForCall[i])
                            ) {
                                updatedColumns3.push(provideDynamicHeaderColumns(metricsListForCall[i], "", false, "", "backend"));
                                updatedExportColumns3.push(provideDynamicExportColumns(metricsListForCall[i], ""))
                            } else {
                                updatedColumns2.push(provideDynamicHeaderColumns(metricsListForCall[i], "", false, "", "backend"));
                                updatedExportColumns2.push(provideDynamicExportColumns(metricsListForCall[i], ""))
                            }

                        }

                        setColumnsAll([
                            ...updatedColumns1,
                            ...updatedColumns2,
                            ...(updatedColumns3.length > 0
                                ? [
                                    {
                                        title: "Pixalate",
                                        children: updatedColumns3,
                                    },
                                ]
                                : []),
                        ])
                        setExportHeader([
                            ...updatedExportColumns1,
                            ...updatedExportColumns2,
                            ...updatedExportColumns3,
                        ])

                        setData([])
                        setTotalData([])
                        setExportData([])
                        setTotal([])
                        setInitialLoad(false)
                        setErrorScreen(true)
                        setBackendLoading(false)

                        if (error?.response) {
                            if (error?.response?.data?.message?.length !== 0) {
                                notifyfailure(error.response.data.message)
                            }
                        } else {
                            notifycatch()
                        }
                    });
            }
            else {
                axios.post(configData.SERVER_URL + `report/`, {
                    "filter": { "dataFor": dataFor, "dimensions": dimensionsList, metrics: metricsListForCall, "publisher_ids": publisher_ids, "zone_ids": zone_ids, "pagination": { "page": page.current, "limit": page.pageSize }, "sort": { "field": sortRelated.name, "ord": sortRelated.type }, },
                    "export": 1,
                    "date": dateRangeCall,
                }, {
                    headers: {
                        "Content-Type": "application/json",
                        "x-access-token": token,
                    },
                    responseType: "blob",
                })
                    .then((response) => {
                        if (response.data) {
                            const blob = new Blob([response.data], {
                                // type: "text/plain;charset=utf-8",
                                type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                            });
                            saveAs(blob, "Report_" + new Date().getTime() + ".xlsx");
                        }

                        setExportBackendLoading(false)


                    })
                    .catch((error) => {
                        if (error?.response) {
                            if (error?.response?.data?.message?.length !== 0) {
                                notifyfailure(error.response.data.message)
                            }
                        } else {
                            notifycatch()
                        }
                        setExportBackendLoading(false)
                    });
            }
        }

    }

    function provideDynamicHeaderColumns(dataColumn, type, partial, columnTimeData, callFrom) {
        let returnData = {}

        //---dimension columns

        if (dataColumn === "publisher_id" || dataColumn === "zone_id") {

            returnData = {
                title: ConstantMapping.Get_Labels_Dimensions[dataColumn],
                dataIndex: dataColumn,
                width: 120,
                key: dataColumn,
                sorter: true,
                sortDirections: ['ascend', 'descend', 'ascend'],
                render: (data, record) => {
                    return (
                        <div >
                            {(data === "" || data === undefined || data === null || data === "-") ?
                                <>
                                    <div className='text_dark'>-</div>
                                </>
                                :
                                <>
                                    {data}
                                </>

                            }
                        </div>
                    )
                },


            }

            if (type === 0) {
                returnData.fixed = 'left'
            }
        }
        if (dataColumn === "publisher" || dataColumn === "zone" || dataColumn === "date" || dataColumn === "country" || dataColumn === "traffic_type" || dataColumn === "format_type" || dataColumn === "site_domain" || dataColumn === "app_bundle") {
            returnData = {
                title: ConstantMapping.Get_Labels_Dimensions[dataColumn],
                dataIndex: dataColumn,
                width: 150,
                key: dataColumn,
                sorter: (callFrom === "backend" && (dataColumn === "traffic_type" || dataColumn === "format_type" || dataColumn === "site_domain" || dataColumn === "app_bundle")) ? false : true,
                sortDirections: ['ascend', 'descend', 'ascend'],
                render: (data, record) => {
                    return (
                        <div >
                            {(data === "" || data === undefined || data === null || data === "-") ?
                                <>
                                    <div className='text_dark'>-</div>
                                </>
                                :
                                <>
                                    {dataColumn === "country" ?
                                        <>

                                            {data?.length > 20 ? (
                                                <Tooltip title={data}>
                                                    {data.slice(0, 20)} ...
                                                </Tooltip>
                                            ) : (
                                                <>{data}</>
                                            )}
                                        </>
                                        :
                                        dataColumn === "site_domain" || dataColumn === "app_bundle" ?
                                            <>

                                                {data?.length > 35 ? (
                                                    <Tooltip title={data}>
                                                        {data.slice(0, 35)} ...
                                                    </Tooltip>
                                                ) : (
                                                    <>{data}</>
                                                )}
                                            </>
                                            :
                                            <>
                                                {data}
                                            </>
                                    }

                                </>

                            }
                        </div>
                    )
                },

            }

            if (type === 0) {
                returnData.fixed = 'left'
            }
        }

        //----number columns

        if (dataColumn === "remotefeed_requests" || dataColumn === "pub_response" || dataColumn === "pub_gross_impressions" || dataColumn === "pub_gross_clicks" || dataColumn === "pub_requests" || dataColumn === "pub_bid" || dataColumn === "impressions" || dataColumn === "givtImpressions" || dataColumn === "sivtImpressions" || dataColumn === "givtSivtImp") {
            returnData = {
                title:
                    <>
                        {
                            (dataColumn === "remotefeed_requests" || dataColumn === "pub_response" || dataColumn === "pub_gross_impressions" || dataColumn === "pub_gross_clicks" || dataColumn === "pub_requests" || dataColumn === "pub_bid") ?
                                <span >
                                    {ConstantMapping.Get_Labels_Metrics[dataColumn]}
                                    <Tooltip
                                        title={dataColumn === "remotefeed_requests" ? "R Requests" :
                                            dataColumn === "pub_response" ? "Responses" :
                                                dataColumn === "pub_gross_impressions" ? "Net Impressions" :
                                                    dataColumn === "pub_gross_clicks" ? "Clicks" :
                                                        dataColumn === "pub_requests" ? "Request" :
                                                            "Bid Responses"
                                        }
                                    >
                                        <img src={reportInfo} alt="" style={{ paddingLeft: "4px", transform: "translateY(-1px)" }} />
                                    </Tooltip>
                                </span> :
                                <>

                                    <span >
                                        {ConstantMapping.Get_Labels_Metrics[dataColumn]}
                                        {partial ?
                                            <Tooltip
                                                title={`Partial Data (${columnTimeData})`}
                                            >
                                                <img src={partialDataIcon} alt="" style={{ paddingLeft: "4px", transform: "translateY(-1px)" }} />
                                            </Tooltip>
                                            :
                                            <Tooltip
                                                title={`Complete Data (${columnTimeData})`}
                                            >
                                                <img src={timeDataIcon} alt="" style={{ paddingLeft: "4px", transform: "translateY(-1px)" }} />
                                            </Tooltip>
                                        }
                                    </span>

                                </>
                        }
                    </>,
                dataIndex: dataColumn,
                width: dataColumn === "givtSivtImp" ? 100 : 150,
                key: dataColumn,
                sorter: (callFrom === "backend" && (dataColumn === "impressions" || dataColumn === "givtImpressions" || dataColumn === "sivtImpressions" || dataColumn === "givtSivtImp")) ? false : true,
                sortDirections: ['ascend', 'descend', 'ascend'],
                render: (data, record) => {
                    return (
                        <>
                            {(data === "" || data === undefined || data === null || data === "-") ?
                                <>
                                    <div className='text_dark'>-</div>
                                </>
                                :
                                <>
                                    {addCommasToNumber(data)}
                                </>
                            }
                        </>
                    )

                },

            }
        }

        //---- % rate columns

        if (dataColumn === "pub_fill_rate" || dataColumn === "pub_coverage_rate" || dataColumn === "pub_win_rate" || dataColumn === "pub_ctr" || dataColumn === "givtImpsRate" || dataColumn === "sivtImpsRate" || dataColumn === "viewability" || dataColumn === "givtSivtRate" || dataColumn === "pub_new_coverage") {
            returnData = {
                title:
                    <>
                        {
                            (dataColumn === "pub_fill_rate" || dataColumn === "pub_coverage_rate" || dataColumn === "pub_win_rate" || dataColumn === "pub_ctr" || dataColumn === "pub_new_coverage") ?
                                <span >
                                    {ConstantMapping.Get_Labels_Metrics[dataColumn]}
                                    <Tooltip title={dataColumn === "pub_fill_rate" ? "(Impressions / Inventory) * 100" :
                                        dataColumn === "pub_coverage_rate" ? "(Responses or Bids/Requests) * 100" :
                                            dataColumn === "pub_win_rate" ? "(Impressions / Total bids) * 100" :
                                                dataColumn === "pub_new_coverage" ? "(Bids / Inventory) * 100" :
                                                    "(Clicks / Impressions) * 100"
                                    }
                                    >
                                        <img src={reportInfo} alt="" style={{ paddingLeft: "4px", transform: "translateY(-1px)" }} />
                                    </Tooltip>
                                </span> :
                                <>

                                    <span >
                                        {ConstantMapping.Get_Labels_Metrics[dataColumn]}
                                        {partial ?
                                            <Tooltip
                                                title={`Partial Data (${columnTimeData})`}
                                            >
                                                <img src={partialDataIcon} alt="" style={{ paddingLeft: "4px", transform: "translateY(-1px)" }} />
                                            </Tooltip>
                                            :
                                            <Tooltip
                                                title={`Complete Data (${columnTimeData})`}
                                            >
                                                <img src={timeDataIcon} alt="" style={{ paddingLeft: "4px", transform: "translateY(-1px)" }} />
                                            </Tooltip>
                                        }
                                    </span>

                                </>
                        }
                    </>
                ,
                dataIndex: dataColumn,
                width: dataColumn === "viewability" ? 170 : dataColumn === "pub_new_coverage" ? 150 : 120,
                key: dataColumn,
                sorter: callFrom === "backend" ? false : true,
                sortDirections: ['ascend', 'descend', 'ascend'],
                render: (data, record) => {
                    return (
                        <>
                            {(data === undefined || data === "" || data === null || data === "-") ?
                                <>
                                    <div className='text_dark'>-</div>
                                </>
                                :
                                <>
                                    {data} %
                                </>
                            }
                        </>
                    )

                },

            }
        }

        //---- $ amount columns

        if (dataColumn === "pub_revenue" || dataColumn === "pub_total_cost" || dataColumn === "profit" || dataColumn === "pub_net_ecpm" || dataColumn === "pub_rpm" || dataColumn === "pub_avg_bidfloor") {
            returnData = {
                title: <span >
                    {ConstantMapping.Get_Labels_Metrics[dataColumn]}
                    <Tooltip title={dataColumn === "pub_revenue" ? "R Revenue" :
                        dataColumn === "pub_total_cost" ? "Net Revenue" :
                            dataColumn === "profit" ? "Revenue - Total Cost" :
                                dataColumn === "pub_net_ecpm" ? " (Total cost/ Impressions) * 1000" :
                                    dataColumn === "pub_avg_bidfloor" ? "Floor" :
                                        "(Total Cost/ Inventory) * 1000000"
                    }>
                        <img src={reportInfo} alt="" style={{ paddingLeft: "4px", transform: "translateY(-1px)" }} />
                    </Tooltip>
                </span>,
                dataIndex: dataColumn,
                width: 150,
                key: dataColumn,
                sorter: (callFrom === "backend" && (dataColumn === "profit" || dataColumn === "pub_net_ecpm" || dataColumn === "pub_rpm")) ? false : true,
                sortDirections: ['ascend', 'descend', 'ascend'],
                render: (data, record) => {
                    return (
                        <>
                            {(data === "" || data === undefined || data === null || data === "-") ?
                                <>
                                    <div className='text_dark'>-</div>
                                </>
                                :
                                <>
                                    $ {addCommasToNumber(data)}
                                </>

                            }
                        </>
                    )

                },
            }
        }

        //pixlate related Data-------------------------------
        if (dataColumn === "discrep") {
            returnData = {
                title:
                    <>

                        <span >
                            {ConstantMapping.Get_Labels_Metrics[dataColumn]}
                            {partial ?
                                <Tooltip
                                    title={`Partial Data (${columnTimeData}) (Gross Ad Count/Impressions)*100`}
                                >
                                    <img src={partialDataIcon} alt="" style={{ paddingLeft: "4px", transform: "translateY(-1px)" }} />
                                </Tooltip>
                                :
                                <Tooltip
                                    title={`Complete Data (${columnTimeData}) (Gross Ad Count/Impressions)*100`}
                                >
                                    <img src={timeDataIcon} alt="" style={{ paddingLeft: "4px", transform: "translateY(-1px)" }} />
                                </Tooltip>
                            }
                        </span>

                    </>,
                dataIndex: dataColumn,
                width: 165,
                key: dataColumn,
                sorter: callFrom === "backend" ? false : true,
                sortDirections: ['ascend', 'descend', 'ascend'],
                render: (data, record) => {
                    return (
                        <>
                            {(data === "" || data === undefined || data === null || data === "-") ?
                                <>
                                    <div className='text_dark'>-</div>
                                </>
                                :
                                <>
                                    <span style={{ color: data.split(" ")[0] === "Low" ? "#0C875E" : data.split(" ")[0] === "High" ? "#FF0000" : "#EBB200" }}>{data.split(" ")[0]}</span>  <span style={{ color: "#475467" }}>{data.split(" ")[1]}</span>
                                </>
                            }
                        </>
                    )
                },

            }
        }

        return returnData
    }

    function provideDynamicExportColumns(data, type) {
        const isPixalate = ConstantMapping.Pixalate_related_keys.includes(data);
        const groupingValue = isPixalate ? "Pixalate" : "";

        if (data === "publisher_id" || data === "zone_id") {
            return { label: ConstantMapping.Get_Labels_Dimensions[data], key: data, group: groupingValue }
        }
        if (data === "publisher" || data === "zone" || data === "date" || data === "country" || data === "traffic_type" || data === "format_type" || data === "site_domain" || data === "app_bundle") {
            return { label: ConstantMapping.Get_Labels_Dimensions[data], key: data, group: groupingValue }
        }
        return { label: ConstantMapping.Get_Labels_Metrics[data], key: data, group: groupingValue }
    }


    useEffect(() => {
        if (!initialLoad && totalData.length > 0) {
            let tempPage = page
            tempPage.current = 1
            setPage(tempPage);
            if (search.length === 0 && paginationProcess === "backend") {
                getDataViaBackend(dateRangePreviousApplied, dimensionsListPreviousApplied, metricsListPreviousApplied, filterRepeaterPreviousApplied, 1, sortObject, "")
            }
            else {
                paginateArray(totalData, tempPage.current, page.pageSize, search, sortObject.name, sortObject.type)
            }

        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [search]);

    const handleTableChange = (pagination, filters, sorter) => {
        setSortObject({ name: sorter.field, type: sorter.order === "ascend" ? 1 : -1 });

        if (paginationProcess === "backend") {
            getDataViaBackend(dateRangePreviousApplied, dimensionsListPreviousApplied, metricsListPreviousApplied, filterRepeaterPreviousApplied, "", { name: sorter.field, type: sorter.order === "ascend" ? 1 : -1 }, "")
        }
        else {
            paginateArray(totalData, page.current, page.pageSize, search, sorter.field, sorter.order === "ascend" ? 1 : -1)
        }

    };


    const handlePageChange = (data) => {

        let tempPage = page
        tempPage.current = data
        setPage(tempPage);


        if (paginationProcess === "backend") {
            getDataViaBackend(dateRangePreviousApplied, dimensionsListPreviousApplied, metricsListPreviousApplied, filterRepeaterPreviousApplied, "", sortObject, "")
        }
        else {
            paginateArray(totalData, tempPage.current, page.pageSize, search, sortObject.name, sortObject.type)
        }

    };

    const handlePageSizeChange = (e) => {
        let tempPage = page
        tempPage.pageSize = e

        if (tempPage.current > 1) {
            if (e * tempPage.current > tempPage.total) {
                tempPage.current = 1
            }
        }
        setPage(tempPage);

        if (paginationProcess === "backend") {
            getDataViaBackend(dateRangePreviousApplied, dimensionsListPreviousApplied, metricsListPreviousApplied, filterRepeaterPreviousApplied, "", sortObject, "")
        }
        else {
            paginateArray(totalData, tempPage.current, tempPage.pageSize, search, sortObject.name, sortObject.type)
        }
    };


    const itemRender = (current, type, originalElement) => {
        if (type === 'prev') {
            return <Link><img src={prevIcon} alt='USP' /></Link>;
        }
        if (type === 'next') {
            return <Link><img src={nextIcon} alt='USP' /></Link>;
        }
        return originalElement;
    };

    const locale = {
        emptyText:
            <>{
                errorScreen ?
                    <div className='no_data_screen'>
                        <div className='text-center'>
                            <img src={error2Data} className='' alt="" />
                            <div className='float_text_div'>
                            </div>
                        </div>
                    </div>
                    :
                    search.trim().length > 0 && backendLoading ?
                        <div className='no_data_screen'>
                            <div className='text-center'>
                                <div className='float_text_div'>
                                </div>
                            </div>
                        </div>
                        :
                        search.trim().length > 0 && !backendLoading ?
                            <div className='no_data_screen'>
                                <div className='text-center'>
                                    <img src={errorData} className='' alt="" />
                                    <div className='float_text_div'>
                                    </div>
                                </div>
                            </div>
                            :
                            backendLoading ?
                                <div className='no_data_screen'>
                                    <div className='text-center'>
                                        <div className='float_text_div'>
                                        </div>
                                    </div>
                                </div>
                                :
                                <div className='no_data_screen' >
                                    <div className='text-center'>
                                        <img src={noData} className='' alt="" />
                                        <div className='float_text_div'>
                                        </div>
                                    </div>
                                </div>
            }
            </>

    };

    ////////////////////////////////dimensions code starts ///////////////////

    const [dimensionsList, setDimensionsList] = useState([]);
    const [dimensionsListPreviousApplied, setDimensionsListPreviousApplied] = useState([]);
    const [dimensionsListOptions, setDimensionsListOptions] = useState(ConstantMapping.Dimensions_Options);
    const [searchDimensionsList, setSearchDimensionsList] = useState('');

    const handleSearchDimensionsList = (e) => {
        setSearchDimensionsList(e.target.value);
    };

    const filterDimensionsList = dimensionsListOptions.filter(option =>
        option.label.toLowerCase()?.includes(searchDimensionsList.toLowerCase())
    );

    // eslint-disable-next-line no-unused-vars
    function handleSelectAllDimensionsList() {
        const allValues = dimensionsListOptions.map(option => option.value);
        let tempDimensionsList = [];
        if (dimensionsList?.length !== dimensionsListOptions?.length) {
            tempDimensionsList = [...allValues];
        } else {
            tempDimensionsList = [];
        }
        setDimensionsList(tempDimensionsList);
        setMetricsListValueError(false)
    }

    function handleDimensionsList(value) {
        let tempDimensionsList = [...dimensionsList]
        let newValue = [];
        if (tempDimensionsList?.includes(value)) {
            newValue = tempDimensionsList.filter((item) => item !== value);

            setDimensionsListOptions((prevOptions) =>
                prevOptions.map((option) => {
                    if (value === "site_domain") {
                        return option.value === "app_bundle"
                            ? { ...option, disabled: false }
                            : option;
                    } else if (value === "app_bundle") {
                        return option.value === "site_domain"
                            ? { ...option, disabled: false }
                            : option;
                    } else {
                        return option;
                    }
                })
            );

        } else {
            newValue = [...tempDimensionsList, value];

            setDimensionsListOptions((prevOptions) =>
                prevOptions.map((option) => {
                    if (value === "site_domain") {
                        return option.value === "app_bundle"
                            ? { ...option, disabled: true }
                            : option;
                    } else if (value === "app_bundle") {
                        return option.value === "site_domain"
                            ? { ...option, disabled: true }
                            : option;
                    } else {
                        return option;
                    }
                })
            );
        }
        tempDimensionsList = newValue
        setDimensionsList(tempDimensionsList)
        setMetricsListValueError(false)

    }

    ////////////////////////////////dimensions code ends ///////////////////

    ///////////////////////////////filter code  starts//////////////////////////
    useEffect(() => {
        let status = Cookies.get("token_xapads_ssp") ? true : false;
        if (status) {
            let token = Cookies.get("token_xapads_ssp");
            let checkRole = jwtDecode(token).role;
            if ((checkRole !== "admin" && checkRole !== "u_admin")) {
                axios
                    .get(configData.SERVER_URL + "user/pubMiniList", {
                        headers: {
                            "Content-Type": "application/json",
                        },
                    })
                    .then((response) => {
                        setFilterRepeaterLabelOptions_publisher(response.data.data);
                    })
                    .catch((error) => { });

                axios
                    .get(configData.SERVER_URL + "zone/zoneMinifiedList", {
                        headers: {
                            "Content-Type": "application/json",
                        },
                    })
                    .then((response) => {
                        setFilterRepeaterLabelOptions_zone(response.data.data);
                    })
                    .catch((error) => { });
            }
        }
    }, []);

    const [filterRepeater, setFilterRepeater] = useState([]);
    const [filterRepeaterPreviousApplied, setFilterRepeaterPreviousApplied] = useState([]);
    const [filterRepeaterLabelOptions] = useState([{ label: "Platform", value: "platform" }, { label: "Publisher", value: "publisher" }, { label: "Zone", value: "zone" }]);
    const [filterRepeaterValueOptions_platform] = useState([{ label: "Adkernel", value: 1 }, { label: "Aniview", value: 2 }]);
    const [filterRepeaterValueOptions_publisher, setFilterRepeaterLabelOptions_publisher] = useState([]);
    const [filterRepeaterValueOptions_zone, setFilterRepeaterLabelOptions_zone] = useState([]);

    const handleAddFilterRepeater = (data) => {
        setFilterRepeater([
            ...filterRepeater,
            {
                label: data,
                value: [],
                valueSearch: "",
                validation_value: false,
            },
        ]);
    };

    const handleRemoveFilterRepeater = (index) => {
        let tempFilter = [...filterRepeater];
        tempFilter = tempFilter.map(obj => ({
            ...obj,
            valueSearch: ""
        }));

        tempFilter.splice(index, 1);
        setFilterRepeater(tempFilter);
    };

    const handleChangeValueSearch = (event, index) => {
        const tempFilter = [...filterRepeater];
        tempFilter[index]["valueSearch"] = event.target.value.trim();
        setFilterRepeater(tempFilter);
    };

    const handleChangeFilterValue = (event, index) => {
        const tempFilter = [...filterRepeater];
        tempFilter[index].value = event
        if (event.length === 0) {
            tempFilter[index].validation_value = true
        }
        else {
            tempFilter[index].validation_value = false
        }

        setFilterRepeater(tempFilter);
    };

    const validateFilterValue = () => {
        let allValuesValid = true;
        setFilterRepeater(prevFilterRepeater =>
            prevFilterRepeater.map(item => {
                let isValueEmpty;

                isValueEmpty = item.value.length === 0;

                if (isValueEmpty) {
                    allValuesValid = false;
                }
                return {
                    ...item,
                    validation_value: isValueEmpty,
                };
            })
        );
        return allValuesValid;
    };

    ////////////////////////////filter code ends////////////////////////////////////////////////// 


    // ///////////////////date range picker code ////////////////////////
    const [dateRange, setDateRange] = useState({
        start: moment().subtract(1, 'days'),
        end: moment().subtract(1, 'days'),
    });
    const [dateRangePreviousApplied, setDateRangePreviousApplied] = useState({
        start: moment().subtract(1, 'days'),
        end: moment().subtract(1, 'days'),
    });

    // const [dateRange, setDateRange] = useState({
    //     start: moment("2025-02-05T18:30:00.000Z"),
    //     end: moment("2025-02-21T18:29:59.999Z")
    // });

    const [labelName, setLabelName] = useState("Yesterday");
    // const { start, end } = dateRange;
    // const label =
    //     start?.format('DD/MM/YYYY') + ' - ' + end?.format('DD/MM/YYYY');

    const datepickerRef = useRef(null);

    // useEffect(() => {
    //     const picker = datepickerRef.current;
    //     if (picker) {
    //         picker.$picker.on("apply.daterangepicker", function (ev, picker) {
    //             const diff = moment(picker.endDate).diff(moment(picker.startDate), "months", true);

    //             if (picker.chosenLabel === "Custom Range" && diff > 1) {
    //                 setTimeout(() => {
    //                     picker.show(); // Reopen the picker immediately after it closes
    //                 }, 10);
    //             }
    //         });
    //     }
    // });


    const [hasClass, setHasClass] = useState(false);

    useEffect(() => {
        const checkClass = () => {
            const daterangepicker = document.querySelector(".daterangepicker");
            if (daterangepicker && window.getComputedStyle(daterangepicker).display === "block") {
                setHasClass(true);
            } else {
                setHasClass(false);
            }
        };

        // Check initially
        checkClass();

        // Observe DOM changes
        const observer = new MutationObserver(checkClass);
        observer.observe(document.body, { attributes: true, childList: true, subtree: true });

        return () => observer.disconnect();
    });

    const containerRef = useRef(null);
    const [openSelectState, setOpenSelectState] = useState({});


    const debounce = (func, delay) => {
        let timeout;
        return (...args) => {
            clearTimeout(timeout);
            timeout = setTimeout(() => func(...args), delay);
        };
    };

    // Handle scroll to close all Select dropdowns
    useEffect(() => {
        const handleScroll = () => {
            if (Object.values(openSelectState).some((isOpen) => isOpen)) {
                setOpenSelectState({}); // Close all open dropdowns
            }
            const cancelBtn = document.querySelector(".daterangepicker .applyBtn"); // Select the cancel button
            if (cancelBtn) {
                cancelBtn.click(); // Simulate a click on the Cancel button
            }
        };

        const debouncedHandleScroll = debounce(handleScroll, 50); // Debounce for smoothness

        const currentDiv = containerRef.current;
        if (currentDiv) {
            currentDiv.addEventListener('scroll', debouncedHandleScroll);
        }


        return () => {
            if (currentDiv) {
                currentDiv.removeEventListener('scroll', debouncedHandleScroll);
            }
        };

    }, [openSelectState]);


    // Function to toggle open state for a specific Select
    const toggleSelectOpen = (key, open) => {
        setOpenSelectState((prevState) => {
            if (prevState[key] === open) return prevState; // Avoid unnecessary updates
            return { ...prevState, [key]: open };
        });
    };


    const refs = {};
    function getRef(key) {
        if (!refs[key]) {
            refs[key] = React.createRef();
        }
        return refs[key];
    }

    useEffect(() => {
        Object.keys(openSelectState).forEach((key) => {
            if (openSelectState[key]) {
                const ref = refs[key];
                setTimeout(() => {
                    ref?.current?.focus();
                }, 0);
            }
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [openSelectState]);

    ////////////////////////////////metrics code starts //////////////////////
    const [metricsListOptions] = useState(ConstantMapping.Metrics_Options_Treeselect);
    const [metricsList, setMetricsList] = useState([]);
    const [metricsListPreviousApplied, setMetricsListPreviousApplied] = useState([]);
    const [metricsListValueError, setMetricsListValueError] = useState(false);
    const [searchMetricsList, setSearchMetricsList] = useState("");

    const handleSearchMetricsList = (e) => {
        setSearchMetricsList(e.target.value);
    };

    const handleSelectAllMetricsList = () => {
        if (metricsList.length === metricsListOptions.length) {
            setMetricsList([]);
        } else {
            setMetricsList(metricsListOptions.map((metric) => metric.value));
        }
        setMetricsListValueError(false);
    };

    const handleMetricsList = (newValue) => {
        setMetricsList(newValue);
        setMetricsListValueError(false)
    };


    const filteredMetricsListOptions = metricsListOptions
        .map(option => ({
            ...option,
            isMatch: option.title.toLowerCase().includes(searchMetricsList.toLowerCase())
        }))
        .sort((a, b) => b.isMatch - a.isMatch)
        .map(({ isMatch, ...rest }) => rest);

    const tPropsMetrics = {
        treeData: searchMetricsList === "" ? metricsListOptions : filteredMetricsListOptions,
        value: metricsList,
        onChange: handleMetricsList,
        treeCheckable: true,
        showCheckedStrategy: SHOW_PARENT,
        placeholder: "",
        popupClassName: 'diff_select_d2 --half',
        switcherIcon: ({ expanded }) => (expanded ?
            <svg width="26" height="24" viewBox="0 0 26 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12.5946 9.5618C12.7941 9.28527 13.2059 9.28527 13.4054 9.5618L16.7581 14.2074C16.9968 14.5381 16.7605 15 16.3527 15L9.64733 15C9.23952 15 9.00324 14.5381 9.24188 14.2074L12.5946 9.5618Z" fill="black" />
            </svg>

            :
            <svg width="26" height="24" viewBox="0 0 26 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M13.4054 14.4382C13.2059 14.7147 12.7941 14.7147 12.5946 14.4382L9.24189 9.7926C9.00324 9.46192 9.23952 9 9.64733 9L16.3527 9C16.7605 9 16.9968 9.46192 16.7581 9.7926L13.4054 14.4382Z" fill="black" />
            </svg>


        ),
        // open: true,
        open: !!openSelectState[`propertyone-02`],
        onDropdownVisibleChange: (open) => toggleSelectOpen(`propertyone-02`, open),
        showSearch: false,
        style: {
            width: "100%",
        },
        dropdownRender: (menu) => (
            <div className="metrics_report_tree_select">
                <div className="custom_inside_searchbar_d2">
                    <Input placeholder="Search" value={searchMetricsList} onChange={(e) => {
                        handleSearchMetricsList(e)
                    }}

                        onKeyDown={(e) => {
                            if (e.key === 'Backspace') {
                                if (searchMetricsList.length > 0) {

                                    const input = getRef(`propertyone-02`).current?.input; // Get input element
                                    const cursorPos = input.selectionStart;; // Get cursor position

                                    if (cursorPos > 0) {
                                        const newValue =
                                            searchMetricsList.slice(0, cursorPos - 1) + // Keep text before cursor (excluding deleted char)
                                            searchMetricsList.slice(cursorPos); // Keep text after cursor

                                        setSearchMetricsList(newValue);
                                        setTimeout(() => {
                                            input.setSelectionRange(cursorPos - 1, cursorPos - 1);
                                        }, 0);
                                    }

                                    e.stopPropagation();
                                    e.preventDefault();


                                } else {

                                    e.stopPropagation();
                                }
                            }
                        }}

                        ref={getRef(`propertyone-02`)}
                        prefix={<SearchOutlined className="search_icon_d2" />} allowClear
                    />
                </div>
                <div
                    // className='select_all_d2'
                    className={`select_all_d2 ${(metricsList?.length > 0 &&
                        ((metricsList.includes("pixalate") ? metricsList.length < (ConstantMapping.Adkernal_related_keys).length + 1 : (ConstantMapping.Adkernal_related_keys).length + (ConstantMapping.Pixalate_related_keys).length))) ? 'intermediate_state' : ''}`}
                >
                    <Checkbox
                        checked={metricsList.length === metricsListOptions.length}
                        onChange={handleSelectAllMetricsList}
                    >
                        Select All
                    </Checkbox>
                </div>
                {menu}
            </div>
        ),

        filterTreeNode: (inputValue, treeNode) => {
            const title = treeNode.title.toLowerCase();
            const searchValueLowerCase = searchMetricsList.toLowerCase();
            return title.includes(searchValueLowerCase);
        },

        inputValue: searchMetricsList,
        // onSearch: (value) => setSearchMetricsList(value),
    };



    //------------------------------save configuration related modal code starts ------------------
    const [isSaveConfigurationModalVisible, setIsSaveConfigurationModalVisible] = useState(false);
    // eslint-disable-next-line no-unused-vars
    const showSaveConfigurationModal = () => {
        setIsSaveConfigurationModalVisible(true);
    };

    const closeSaveConfigurationModal = () => {
        setIsSaveConfigurationModalVisible(false);
        resetModalSaveConigurationData()
    };

    function resetModalSaveConigurationData() {
        setConfigurationName("");
        setConfigurationNameIsRequiredError(false)
    }


    const [configurationName, setConfigurationName] = useState("");
    const [configurationButtonProcessing] = useState(false);
    const [configurationNameIsRequiredError, setConfigurationNameIsRequiredError] = useState(false);

    function onChangeConfigurationName(event) {
        setConfigurationNameIsRequiredError(false);
        setConfigurationName(event.target.value);
    }

    function onBlurConfigurationName(event) {
        if (event.target.value.trim().length === 0) {
            setConfigurationNameIsRequiredError(true);
        }
        setConfigurationName(event.target.value.trim());
    }

    function handleConfigurationDataSave() {

        if (configurationName.trim() !== "") {
            if (configurationNameIsRequiredError === false) {

                let status = Cookies.get("token_xapads_ssp") ? true : false;
                if (status) {

                    let token = Cookies.get("token_xapads_ssp");

                    let dataFor = 0;
                    let publisher_ids = [];
                    let zone_ids = []

                    let dateRangeCall = {
                        startDate: dateRange?.start.format('YYYY-MM-DD'),
                        endDate: dateRange?.end.format('YYYY-MM-DD')
                    };

                    if (filterRepeater.length > 0) {
                        for (let i = 0; i < filterRepeater.length; i++) {
                            if (filterRepeater[i]["label"] === "platform") {
                                if (filterRepeater[i]["value"].length === 1) {
                                    dataFor = filterRepeater[i]["value"]
                                }
                            }

                            if (filterRepeater[i]["label"] === "publisher") {
                                publisher_ids = filterRepeater[i]["value"]
                            }

                            if (filterRepeater[i]["label"] === "zone") {
                                zone_ids = filterRepeater[i]["value"]
                            }
                        }
                    }

                    let payload = {
                        "filter": { "dataFor": dataFor, "dimensions": dimensionsList, metrics: metricsList, "publisher_ids": publisher_ids, "zone_ids": zone_ids },
                        // "date": dateRangeCall,
                        "name": configurationName,
                        "dateRangeLabel": labelName,
                        // "dateRangeTimeStamp": dateRange,
                        "filterArray": filterRepeater.map(({ search, validation_value, ...rest }) => rest)
                    }

                    if (labelName === "Custom Range") {
                        payload.dateRangeTimeStamp = dateRange
                        payload.date = dateRangeCall
                    }

                    axios.post(configData.SERVER_URL + `saveReport/test`, payload, {
                        headers: {
                            "Content-Type": "application/json",
                            "x-access-token": token,
                        },
                    })
                        .then((response) => {
                            if (response.data.message) {
                                notifysuccess(response.data.message)
                                resetModalSaveConigurationData()
                            }
                        })
                        .catch((error) => {
                            if (error?.response) {
                                if (error?.response?.data?.message?.length !== 0) {
                                    notifyfailure(error.response.data.message)
                                }
                            } else {
                                notifycatch()
                            }
                        });
                }

            }

        }
        else {
            if (configurationName.trim() === "") {
                setConfigurationNameIsRequiredError(true)
            }
        }

    }


    //------------------------------save configuration related modal code ends ------------------


    return (
        <>


            <div className="container_box--wrapper pt_header"
                id="hello"
                ref={containerRef}
                // style={{ opacity: pageView === "table" ? 1 : 0, display: pageView === "table" ? "block" : "none" }}
                style={{
                    height: "100vh",
                    overflowY: "auto"
                }}
            >
                <div className="container_box--wrapper--title d_flex justify-content-between">
                    <h1 className="heading fw_600">
                        Reports

                    </h1>
                </div>

                {!pageLoad ?
                    <>

                        <div className="report_filter" >

                            <Row gutter={16} className=" mb_10">
                                <Col span={2} className="d_flex justify_content_start align_items_start gap_8">
                                    <img src={RangeCalendar} alt="" style={{ paddingTop: "0.3rem" }} />
                                    <label className='form_label font_size'>Date Range: </label>
                                </Col>
                                <Col span={5}>
                                    <div className='form_content_block--group '
                                        style={{ cursor: "pointer" }}
                                    >
                                        <DateRangePicker
                                            ref={datepickerRef}
                                            startDate={dateRange.start}
                                            endDate={dateRange.end}

                                            initialSettings={{
                                                containerClass: "custom-class-1",
                                                alwaysShowCalendars: true,
                                                startDate: dateRange.start,
                                                endDate: dateRange.end,
                                                locale: {
                                                    format: "DD/MM/YYYY",
                                                },
                                                maxDate: new Date(),
                                                ranges: {
                                                    Today: [moment().toDate(), moment().toDate()],
                                                    Yesterday: [
                                                        moment().subtract(1, 'days').toDate(),
                                                        moment().subtract(1, 'days').toDate(),
                                                    ],
                                                    'Last 7 Days': [
                                                        moment().subtract(6, 'days').toDate(),
                                                        moment().toDate(),
                                                    ],
                                                    'Last 30 Days': [
                                                        moment().subtract(29, 'days').toDate(),
                                                        moment().toDate(),
                                                    ],
                                                    'This Month': [
                                                        moment().startOf('month').toDate(),
                                                        moment().endOf('month').toDate(),
                                                    ],
                                                    'Last Month': [
                                                        moment().subtract(1, 'month').startOf('month').toDate(),
                                                        moment().subtract(1, 'month').endOf('month').toDate(),
                                                    ],
                                                },
                                            }}

                                            onCallback={(start, end, label) => {
                                                const diffDays = moment(end).diff(moment(start), "days");
                                                if (label === "Custom Range" && diffDays > 31) {
                                                    notifyfailure("Custom range cannot be greater than 31 days!");
                                                } else {
                                                    setDateRange({ start: start, end: end });
                                                    setLabelName(label)
                                                    // setApicall(!apiCall);
                                                }
                                            }
                                            }
                                        >
                                            <div id="reportrange"
                                                className={hasClass ? "daterange_back_shadow form_select basic d_flex justify_comtent_start align_items_center height_32 border_radius_6 width_196 " : "form_select basic d_flex justify_comtent_start align_items_center  height_32 border_radius_6 width_196"}
                                            >
                                                {/* <span className="pl_10">{labelName === "Custom Range" ? label : labelName}</span> */}
                                                <span className="pl_10" style={{ fontFamily: "Poppins", fontSize: "13px", paddingTop: "2px" }}>

                                                    {/* {label} */}
                                                    {dateRange.start.format('DD/MM/YYYY')} - {dateRange.end.format('DD/MM/YYYY')}
                                                </span>
                                                <i className="fa fa-caret-down"></i>
                                            </div>
                                        </DateRangePicker>
                                    </div>
                                </Col>
                            </Row>




                            <Row gutter={16} className="position_relative mb_10">
                                <Col span={2} className="d_flex justify_content_start align_items_start gap_8">
                                    <img src={dimensionIcon} alt="" style={{ paddingTop: "0.3rem" }} />
                                    <label className='form_label'>Dimensions: </label>
                                </Col>
                                <Col span={22}>
                                    <div className="checkbox_value_select_d2 multi_select_tag_d2 w-100 form_content_block--group">
                                        <Select
                                            id="adcodeSelect"
                                            value={dimensionsList}
                                            popupClassName='diff_select_d2 --half'
                                            // open={true}
                                            showSearch={false}
                                            placeholder='- Select -'
                                            className="form_select basic height_multi_select border_radius_6"
                                            mode='multiple'
                                            onChange={(event) => {
                                                setDimensionsList(event);
                                                setDimensionsListOptions((prevOptions) =>
                                                    prevOptions.map((option) => {
                                                        if (!event.includes("site_domain") && option.value === "app_bundle") {
                                                            return { ...option, disabled: false };
                                                        }
                                                        if (!event.includes("app_bundle") && option.value === "site_domain") {
                                                            return { ...option, disabled: false };
                                                        }
                                                        return option;
                                                    })
                                                );

                                                setMetricsListValueError(false)
                                            }}
                                            open={!!openSelectState[`propertyone-01`]}
                                            onDropdownVisibleChange={(open) => toggleSelectOpen(`propertyone-01`, open)}
                                            dropdownRender={menu => (
                                                <>
                                                    <div className="custom_inside_searchbar_d2">
                                                        <Input placeholder="Search" value={searchDimensionsList} onChange={(e) => {
                                                            handleSearchDimensionsList(e)
                                                            // e.stopPropagation()
                                                            // e.preventDefault();
                                                        }}
                                                            onKeyDown={(e) => {
                                                                if (e.key === 'Backspace') {
                                                                    if (searchDimensionsList.length > 0) {

                                                                        const input = getRef(`propertyone-01`).current?.input; // Get input element
                                                                        const cursorPos = input.selectionStart;; // Get cursor position

                                                                        if (cursorPos > 0) {
                                                                            const newValue =
                                                                                searchDimensionsList.slice(0, cursorPos - 1) + // Keep text before cursor (excluding deleted char)
                                                                                searchDimensionsList.slice(cursorPos); // Keep text after cursor

                                                                            setSearchDimensionsList(newValue);
                                                                            setTimeout(() => {
                                                                                input.setSelectionRange(cursorPos - 1, cursorPos - 1);
                                                                            }, 0);
                                                                        }

                                                                        e.stopPropagation();
                                                                        e.preventDefault();


                                                                    } else {

                                                                        e.stopPropagation();
                                                                    }
                                                                }
                                                            }}

                                                            ref={getRef(`propertyone-01`)}
                                                            prefix={<SearchOutlined className="search_icon_d2" />} allowClear />
                                                    </div>
                                                    {/* <div
                                                        className={`select_all_d2 ${(dimensionsList?.length > 0 && dimensionsList?.length !== dimensionsListOptions?.length) ? 'intermediate_state' : ''}`}
                                                        onClick={() => handleSelectAllDimensionsList()}
                                                    >
                                                        <Checkbox
                                                            checked={dimensionsList?.length === dimensionsListOptions?.length}
                                                            onClick={(e) => e.stopPropagation()}
                                                        >
                                                            Select All
                                                        </Checkbox>
                                                    </div> */}
                                                    {menu}
                                                </>
                                            )}
                                        >
                                            {[
                                                ...filterDimensionsList?.filter(option => dimensionsList?.includes(option.value)), // Checked options first
                                                ...filterDimensionsList?.filter(option => !dimensionsList?.includes(option.value)) // Unchecked options next
                                            ].map(option => (
                                                <Option key={option.value} value={option.value}
                                                    className={option.disabled ? "disabled_checkbox_select_2" : ""}
                                                >
                                                    <div
                                                        onClick={() => handleDimensionsList(option.value)}
                                                        style={{ display: 'flex', alignItems: 'center' }}
                                                    >
                                                        <Checkbox
                                                            checked={dimensionsList?.includes(option.value)}
                                                            onClick={(e) => e.stopPropagation()}
                                                            disabled={option.disabled}
                                                        >
                                                            {option.label}
                                                        </Checkbox>
                                                    </div>
                                                </Option>
                                            ))}
                                        </Select>
                                    </div>
                                    <span className="plus_select">
                                        <img src={selectPlusIcon} alt="" />
                                    </span>
                                    {dimensionsList.length > 0 &&
                                        <span className="clear_all"
                                            onClick={() => {
                                                setDimensionsList([]);
                                                setDimensionsListOptions((prevOptions) =>
                                                    prevOptions.map((option) => {
                                                        return { ...option, disabled: false };
                                                    })
                                                );
                                                setMetricsListValueError(false)
                                            }}
                                        >
                                            Clear all
                                        </span>
                                    }
                                </Col>
                            </Row>
                            {/* 
                            <div className="w-896">
                    <Form.Group className="mt-20" controlId="">
                      <Form.Label>Browsers * </Form.Label>
                      <TreeSelect {...tPropsBrowser} />
                      {browserListError && (
                        <span className="alert_text">
                          Minimum One Selection is required
                        </span>
                      )}
                    </Form.Group>
                  </div> */}

                            <Row gutter={16} className="position_relative mb_10">
                                <Col span={2} className="d_flex justify_content_start align_items_start gap_8">
                                    <img src={metricIcon} alt="" style={{ paddingTop: "0.3rem" }} />
                                    <label className='form_label'>Metrics: </label>
                                </Col>
                                <Col span={22}>
                                    <div className="checkbox_value_select_d2 multi_select_tag_d2 w-100 form_content_block--group">
                                        <TreeSelect  {...tPropsMetrics}
                                            treeDefaultExpandAll
                                            className={metricsListValueError ? "form_select basic height_multi_select border_radius_6 error" : "form_select basic height_multi_select border_radius_6"}
                                        />
                                    </div>
                                    <span className="plus_select">
                                        <img src={selectPlusIcon} alt="" />
                                    </span>
                                    {metricsList.length > 0 &&
                                        <span className="clear_all"
                                            onClick={() => { setMetricsList([]); setMetricsListValueError(false) }}
                                        >
                                            Clear all
                                        </span>
                                    }
                                </Col>
                            </Row>

                            <Row gutter={16} className="position_relative mb_10">
                                {filterRepeater.length === 0 &&
                                    <Col span={2} className="d_flex justify_content_start align_items_start gap_8">
                                        <img src={filterIcon} className="img-fluid" alt="" style={{ paddingTop: "0.3rem" }} />
                                        <label className='form_label'>Filters: </label>
                                    </Col>
                                }

                                {filterRepeater.map((x, i) => {
                                    return (
                                        <>

                                            <Col span={2} className="d_flex justify_content_start align_items_start gap_8 mb_10">
                                                {i === 0 ?
                                                    <>
                                                        <img src={filterIcon} className="img-fluid" alt="" style={{ paddingTop: "0.3rem" }} />
                                                        <label className='form_label'>Filter</label>
                                                    </>
                                                    :
                                                    <></>
                                                }
                                            </Col>

                                            <Col span={22} className="d_flex justify_content_between align_items_start mb_10">
                                                <div className='d-flex align-items-center justify-content-between '>
                                                    <span className="remove_icon" onClick={() => handleRemoveFilterRepeater(i)}>
                                                        <img src={removeIcon} alt="Delete"

                                                        />
                                                    </span>
                                                </div>

                                                <div className="form_content_block--group mb_0 hide_open_searchplaceholder_d2 hide_caret_after_select_value ">
                                                    <Input
                                                        className="form_control basic height_32 border_radius_6"
                                                        value={x.label}
                                                        style={{ textTransform: "capitalize", pointerEvents: "none" }}
                                                    />
                                                </div>
                                                <span
                                                    className="is_text_fiter padding_top "
                                                > is
                                                </span>

                                                <Col span={20} className="add_property_select_big">
                                                    <div className="checkbox_value_select_d2 multi_select_tag_d2 w-100 form_content_block--group">
                                                        <Select
                                                            id="adcodeSelect"
                                                            value={x.value}
                                                            popupClassName='diff_select_d2 --report_filter_select'
                                                            // open={true}
                                                            showSearch={false}
                                                            placeholder='- Select -'
                                                            className={x.validation_value ? "form_select basic error height_multi_select height_multi_select_filter border_radius_6" : "form_select basic  height_multi_select height_multi_select_filter border_radius_6"}
                                                            mode='multiple'
                                                            onChange={(event) => { handleChangeFilterValue(event, i) }}
                                                            open={!!openSelectState[`propertyone-${i}`]}
                                                            onDropdownVisibleChange={(open) => toggleSelectOpen(`propertyone-${i}`, open)}
                                                            dropdownRender={menu => (
                                                                <>
                                                                    <div className="custom_inside_searchbar_d2">
                                                                        <Input placeholder="Search" value={x.valueSearch} onChange={(e) => {
                                                                            handleChangeValueSearch(e, i)
                                                                            // e.stopPropagation()
                                                                            // e.preventDefault();

                                                                        }}
                                                                            onKeyDown={(e) => {
                                                                                if (e.key === 'Backspace') {
                                                                                    if (x.valueSearch.length > 0) {

                                                                                        const input = getRef(`propertyone-${i}`).current?.input; // Get input element
                                                                                        const cursorPos = input.selectionStart;; // Get cursor position

                                                                                        if (cursorPos > 0) {
                                                                                            const tempFilter = [...filterRepeater];
                                                                                            const newValue =
                                                                                                x.valueSearch.slice(0, cursorPos - 1) + // Keep text before cursor (excluding deleted char)
                                                                                                x.valueSearch.slice(cursorPos); // Keep text after cursor
                                                                                            tempFilter[i].valueSearch = newValue
                                                                                            setFilterRepeater(tempFilter);

                                                                                            setTimeout(() => {
                                                                                                input.setSelectionRange(cursorPos - 1, cursorPos - 1);
                                                                                            }, 0);
                                                                                        }

                                                                                        e.stopPropagation();
                                                                                        e.preventDefault();
                                                                                    } else {

                                                                                        e.stopPropagation();
                                                                                    }
                                                                                }
                                                                            }}
                                                                            ref={getRef(`propertyone-${i}`)}
                                                                            prefix={<SearchOutlined className="search_icon_d2" />} allowClear />
                                                                    </div>
                                                                    {menu}
                                                                </>
                                                            )}
                                                        >
                                                            {(x.label === "publisher" ?
                                                                [
                                                                    ...filterRepeaterValueOptions_publisher?.filter(option => x.value?.includes(option.value)),
                                                                    ...filterRepeaterValueOptions_publisher?.filter(option => !x.value?.includes(option.value))
                                                                ] :
                                                                x.label === "zone" ?
                                                                    [
                                                                        ...filterRepeaterValueOptions_zone?.filter(option => x.value?.includes(option.value)),
                                                                        ...filterRepeaterValueOptions_zone?.filter(option => !x.value?.includes(option.value))
                                                                    ] :
                                                                    [
                                                                        ...filterRepeaterValueOptions_platform?.filter(option => x.value?.includes(option.value)),
                                                                        ...filterRepeaterValueOptions_platform?.filter(option => !x.value?.includes(option.value))
                                                                    ]
                                                            )?.filter((option) =>
                                                                option.label.toLowerCase().includes(x.valueSearch?.toLowerCase() || '')
                                                            ).map(option => (
                                                                <Option key={option.value} value={option.value}>
                                                                    <div
                                                                        onClick={() => handleChangeFilterValue(option.value, i)}
                                                                        style={{ display: 'flex', alignItems: 'center' }}
                                                                    >
                                                                        <Checkbox
                                                                            checked={x.value?.includes(option.value)}
                                                                            onClick={(e) => e.stopPropagation()}
                                                                        >
                                                                            {option.label}
                                                                        </Checkbox>
                                                                    </div>
                                                                </Option>
                                                            ))}
                                                        </Select>
                                                    </div>
                                                    {/* <span className="plus_select">
                                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M0.673739 22.2225C0.386419 21.7933 0.179953 21.3054 0.0761361 20.7806L0.56663 20.6836C0.52297 20.4629 0.5 20.2344 0.5 20V19H0V17H0.5V15H0V13H0.5V11H0V9H0.5V7H0V5H0.5V4C0.5 3.76561 0.52297 3.53708 0.56663 3.31639L0.0761362 3.21935C0.179953 2.69457 0.386418 2.2067 0.673738 1.77754L1.08922 2.0557C1.3449 1.6738 1.6738 1.3449 2.0557 1.08922L1.77754 0.673739C2.2067 0.386419 2.69457 0.179953 3.21935 0.0761362L3.31639 0.56663C3.53708 0.52297 3.76561 0.5 4 0.5H5V0H7V0.5H9V0H11V0.5H13V0H15V0.5H17V0H19V0.5H20C20.2344 0.5 20.4629 0.52297 20.6836 0.56663L20.7806 0.0761361C21.3054 0.179953 21.7933 0.386418 22.2225 0.673738L21.9443 1.08922C22.3262 1.3449 22.6551 1.6738 22.9108 2.0557L23.3263 1.77754C23.6136 2.2067 23.82 2.69457 23.9239 3.21935L23.4334 3.31639C23.477 3.53708 23.5 3.76561 23.5 4V5H24V7H23.5V9H24V11H23.5V13H24V15H23.5V17H24V19H23.5V20C23.5 20.2344 23.477 20.4629 23.4334 20.6836L23.9239 20.7806C23.82 21.3054 23.6136 21.7933 23.3263 22.2225L22.9108 21.9443C22.6551 22.3262 22.3262 22.6551 21.9443 22.9108L22.2225 23.3263C21.7933 23.6136 21.3054 23.82 20.7806 23.9239L20.6836 23.4334C20.4629 23.477 20.2344 23.5 20 23.5H19V24H17V23.5H15V24H13V23.5H11V24H9V23.5H7V24H5V23.5H4C3.76561 23.5 3.53708 23.477 3.31639 23.4334L3.21935 23.9239C2.69457 23.82 2.2067 23.6136 1.77754 23.3263L2.0557 22.9108C1.6738 22.6551 1.3449 22.3262 1.08922 21.9443L0.673739 22.2225Z" stroke="#98A2B3" stroke-dasharray="2 2" />
                                                    <path d="M12 7.33337V16.6667" stroke="#98A2B3" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
                                                    <path d="M7.33325 12H16.6666" stroke="#98A2B3" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
                                                </svg>
                                            </span> */}

                                                    {filterRepeater[i].value.length > 0 &&
                                                        <span className="clear_all"
                                                            onClick={() => {
                                                                const tempFilter = [...filterRepeater];
                                                                tempFilter[i].value = []
                                                                setFilterRepeater(tempFilter);
                                                            }}
                                                        >
                                                            Clear all
                                                        </span>
                                                    }
                                                </Col>
                                            </Col>
                                        </>
                                    )
                                }
                                )}

                                {filterRepeater.length > 0 &&
                                    <Col span={2}> </Col>
                                }


                                {filterRepeaterLabelOptions.filter(
                                    (item) => !filterRepeater.some((selected) => selected.label === item.value)
                                ).length > 0 &&
                                    <Col span={2}
                                        className="add_property"
                                    >
                                        <div className='addnewform_d2 addnewform_filter_d2 scroll_option_div'>
                                            <Dropdown className="inner_dropdown_btn_d2 bg-transparent">
                                                <Dropdown.Toggle className="dropdown-autoclose-false px-2" id="dropdown-basic"
                                                    disabled={filterRepeaterLabelOptions.filter(
                                                        (item) => !filterRepeater.some((selected) => selected.label === item.value)
                                                    ).length === 0}
                                                >
                                                    <img src={addIcon} className="m-0" alt='Add Property' /> Add Property
                                                </Dropdown.Toggle>

                                                <Dropdown.Menu>
                                                    {filterRepeaterLabelOptions.filter(
                                                        (item) => !filterRepeater.some((selected) => selected.label === item.value)
                                                    ).map((item) => (
                                                        <Dropdown.Item onClick={() => { handleAddFilterRepeater(item.value) }}>{item.label}</Dropdown.Item>
                                                    ))}
                                                </Dropdown.Menu>
                                            </Dropdown>
                                        </div>
                                    </Col>
                                }
                            </Row>

                            <div className="hr_custom_filter"></div>

                            <>

                                <div className="btn_group justify-content-start gap_8">
                                    <button className='btn btn_primary w_fit_content footer_generate'
                                        disabled={dimensionsList.length === 0 || metricsList.length === 0}

                                        // onClick={() => { setApicall(!apiCall) }}
                                        onClick={() => {


                                            if (validateFilterValue()) {

                                                if (metricsList.includes("pub_avg_bidfloor") && !dimensionsList.includes("zone")) {
                                                    setMetricsListValueError(true);
                                                    notifyfailure("Metric Floor can only be applied with the zone dimension.");
                                                    return;
                                                }

                                                if (!(dimensionsList.includes("zone") || dimensionsList.includes("publisher") || dimensionsList.includes("site_domain") || dimensionsList.includes("app_bundle"))) {
                                                    const metricsToCheck = [...ConstantMapping.Pixalate_related_keys, "pixalate"];
                                                    if (metricsList.some(metric => metricsToCheck.includes(metric))) {
                                                        setMetricsListValueError(true)
                                                        notifyfailure("Pixalate metrics can only be applied with zone or publisher dimension")
                                                        return
                                                    }
                                                }
                                                else {
                                                    if (dimensionsList.includes("date") || dimensionsList.includes("country") || dimensionsList.includes("traffic_type") || dimensionsList.includes("format_type")) {
                                                        const metricsToCheck = [...ConstantMapping.Pixalate_related_keys, "pixalate"];
                                                        if (metricsList.some(metric => metricsToCheck.includes(metric))) {
                                                            setMetricsListValueError(true)

                                                            const labelsArray = ConstantMapping.Dimensions_Options
                                                                .filter(item => dimensionsList.filter(item => item !== "zone" && item !== "publisher" && item !== "site_domain" && item !== "app_bundle").includes(item.value)) // Filter only objects with matching values
                                                                .map(item => item.label)

                                                            notifyfailure(`Pixalate metrics can't be applied with the following dimensions:  ${labelsArray?.join(", ")}.`)
                                                            return
                                                        }
                                                    }
                                                }

                                                const metricsToCheckAdkernel = ConstantMapping.Adkernal_related_keys

                                                if (!metricsList.some(metric => metricsToCheckAdkernel.includes(metric))) {
                                                    setMetricsListValueError(true)
                                                    notifyfailure("Please select atleast one metric other than Pixalate metrics")
                                                    return
                                                }

                                                let dataForCheck = [0]
                                                if (filterRepeater.length > 0) {
                                                    for (let i = 0; i < filterRepeater.length; i++) {
                                                        if (filterRepeater[i]["label"] === "platform") {
                                                            if (filterRepeater[i]["value"].length === 1) {
                                                                dataForCheck = filterRepeater[i]["value"]
                                                            }
                                                        }

                                                    }
                                                }

                                                if ((dimensionsList.includes("site_domain") || dimensionsList.includes("app_bundle")) && dataForCheck[0] === 0) {
                                                    if (dimensionsList.includes("site_domain") && dimensionsList.includes("app_bundle")) {
                                                        notifyfailure("Combined Report can not be generated with Site Domain and App Bundle Dimension. Please choose a particular platform.")
                                                    }
                                                    else if (dimensionsList.includes("site_domain")) {
                                                        notifyfailure("Combined Report can not be generated with Site Domain Dimension. Please choose a particular platform.")
                                                    }
                                                    else {
                                                        notifyfailure("Combined Report can not be generated with App Bundle Dimension. Please choose a particular platform.")
                                                    }

                                                    return
                                                }
                                                else if ((dimensionsList.includes("site_domain") || dimensionsList.includes("app_bundle")) && dataForCheck[0] === 1) {
                                                    setPaginationProcess("backend")
                                                    setLoading(false)
                                                    setInitialLoad(true)
                                                    setData([])
                                                    setTotalData([])
                                                    setExportData([])
                                                    setTotal([])
                                                    setSortObject({
                                                        name: "",
                                                        type: ""
                                                    })

                                                    let tempPage = { ...page }
                                                    tempPage.current = 1
                                                    tempPage.total = 0
                                                    setPage(tempPage)

                                                    setDateRangePreviousApplied(dateRange)
                                                    setDimensionsListPreviousApplied(dimensionsList)
                                                    setMetricsListPreviousApplied(metricsList)
                                                    setFilterRepeaterPreviousApplied(filterRepeater)

                                                    getDataViaBackend(dateRange, dimensionsList, metricsList, filterRepeater, 1, {
                                                        name: "",
                                                        type: ""
                                                    }, "")
                                                }
                                                else {
                                                    setPaginationProcess("frontend")
                                                    getDataViaFrontend()
                                                }

                                            }
                                        }}
                                    >
                                        Generate Report
                                    </button>

                                    {/* {(dimensionsList.length === 0 || metricsList.length === 0) ?
                                        <></>

                                        // <button className='btn btn_white_outline w_fit_content footer_config d-flex gap_5  justify_content_center align_items_center'
                                        //     style={{ pointerEvents: "none" }}
                                        // >
                                        //     <img src={mediaKitIcon} alt='USP' />
                                        //     <span>Save Configuration</span>
                                        // </button>
                                        :

                                        <button className='btn btn_white_outline w_fit_content footer_config d-flex gap_5  justify_content_center align_items_center'
                                            disabled={dimensionsList.length === 0 || metricsList.length === 0}
                                            onClick={() => {
                                                if (validateFilterValue()) {
                                                    if (!dimensionsList.includes("zone")) {
                                                        const metricsToCheck = ["impressions", "givtImpressions", "givtImpsRate", "sivtImpressions", "sivtImpsRate", "viewability", "givtSivtRate", "givtSivtImp", "discrep"];
                                                        if (metricsList.some(metric => metricsToCheck.includes(metric))) {
                                                            setMetricsListValueError(true)
                                                            notifyfailure("Pixalate metrics can only be applied with zone dimension")
                                                            return
                                                        }
                                                    }

                                                    const metricsToCheckAdkernel = ["remotefeed_requests", "pub_response", "pub_gross_impressions", "pub_gross_clicks", "pub_requests", "pub_bid", "pub_fill_rate", "pub_coverage_rate", "pub_win_rate", "pub_ctr", "pub_revenue", "pub_total_cost", "profit", "pub_net_ecpm", "pub_rpm"]

                                                    if (!metricsList.some(metric => metricsToCheckAdkernel.includes(metric))) {
                                                        setMetricsListValueError(true)
                                                        notifyfailure("Please select atleast one metric other than Pixalate metrics")
                                                        return
                                                    }

                                                    showSaveConfigurationModal()
                                                }
                                            }}
                                        >
                                            <img src={mediaKitIcon} alt='USP' />
                                            <span>Save Configuration</span>
                                        </button>

                                    } */}



                                </div>

                            </>


                        </div>


                        {/* <div className="numbres_box_div_list">
                            <div className="numbres_box">
                                <div>
                                    <h2>12,788,128</h2>
                                    <span>Requests</span>
                                </div>
                                <div className="icon_bg">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                        <path d="M3.4375 15.9375C4.64562 15.9375 5.625 14.9581 5.625 13.75C5.625 12.5419 4.64562 11.5625 3.4375 11.5625C2.22938 11.5625 1.25 12.5419 1.25 13.75C1.25 14.9581 2.22938 15.9375 3.4375 15.9375Z" stroke="#CC2200" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                        <path d="M15.625 3.125L18.75 6.25L15.625 9.375" stroke="#CC2200" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                        <path d="M5.625 13.75H6.25C7.24456 13.75 8.19839 13.3549 8.90165 12.6517C9.60491 11.9484 10 10.9946 10 10C10 9.00544 10.3951 8.05161 11.0983 7.34835C11.8016 6.64509 12.7554 6.25 13.75 6.25H18.75" stroke="#CC2200" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                    </svg>
                                </div>
                            </div>
                            <div className="numbres_box">
                                <div>
                                    <h2>45,211,897</h2>
                                    <span>Bids</span>
                                </div>
                                <div className="icon_bg">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                        <path d="M9.51109 8.33337L3.3586 14.515C3.19545 14.6769 3.06597 14.8695 2.97761 15.0817C2.88924 15.2939 2.84375 15.5214 2.84375 15.7513C2.84375 15.9811 2.88924 16.2087 2.97761 16.4209C3.06597 16.633 3.19545 16.8256 3.3586 16.9875C3.68807 17.3153 4.13389 17.4992 4.5986 17.4992C5.06331 17.4992 5.50912 17.3153 5.8386 16.9875L12.0111 10.8334M15.1003 12.7442L17.2553 10.5892C17.4115 10.4329 17.4992 10.221 17.4992 10C17.4992 9.77907 17.4115 9.56714 17.2553 9.41087L10.9336 3.0892C10.7773 2.93298 10.5654 2.84521 10.3444 2.84521C10.1235 2.84521 9.91154 2.93298 9.75526 3.0892L7.60026 5.2442C7.44404 5.40048 7.35627 5.6124 7.35627 5.83337C7.35627 6.05434 7.44404 6.26626 7.60026 6.42254L13.9219 12.7442C14.0782 12.9004 14.2901 12.9882 14.5111 12.9882C14.7321 12.9882 14.944 12.9004 15.1003 12.7442Z" stroke="#125F64" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                    </svg>
                                </div>
                            </div>
                            <div className="numbres_box">
                                <div>
                                    <h2>78,349,102</h2>
                                    <span>Impressions</span>
                                </div>
                                <div className="icon_bg">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                        <path d="M12.2109 15.9141L10 18.125L7.78906 15.9141" stroke="#0098CD" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                        <path d="M10 12.5V18.125" stroke="#0098CD" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                        <path d="M7.78906 4.08594L10 1.875L12.2109 4.08594" stroke="#0098CD" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                        <path d="M10 7.5V1.875" stroke="#0098CD" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                        <path d="M4.08594 12.2109L1.875 10L4.08594 7.78906" stroke="#0098CD" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                        <path d="M7.5 10H1.875" stroke="#0098CD" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                        <path d="M15.9141 7.78906L18.125 10L15.9141 12.2109" stroke="#0098CD" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                        <path d="M12.5 10H18.125" stroke="#0098CD" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                    </svg>
                                </div>
                            </div>
                        </div> */}


                        {!loading &&
                            <>

                                <div className="d_flex justify_content_between" style={{ marginBottom: "1rem" }}>
                                    <div className="form_content_block--group w-auto">
                                        {!initialLoad &&
                                            <div className="tooltip_svg_icon_d2 position-relative">
                                                <Input
                                                    type='text'
                                                    className='form_control basic md search_input w_table_search'
                                                    placeholder="Search"
                                                    value={search}
                                                    disabled={backendLoading}
                                                    onChange={(e) => {
                                                        setSearch(e.target.value)
                                                    }}
                                                />
                                                {/* <Tooltip title="Search is limited to Publisher Id, Publisher Name, Zone Id, Zone Name, Country and Traffic Type."
                                                    placement="right"
                                                    overlayInnerStyle={{
                                                        width: "500px"
                                                    }}
                                                >
                                                    <img src={infoIcon} alt="" />
                                                </Tooltip> */}
                                            </div>
                                        }
                                    </div>
                                    <div className="custom_filter_design_d2">
                                        {!initialLoad &&
                                            <>
                                                <div className="export_btn_hover_d2">
                                                    {exportData.length === 0 || backendLoading ?
                                                        <Button
                                                            className="export_btn_d2"
                                                            disabled={true}
                                                            style={{ pointerEvents: "none" }}
                                                            icon={
                                                                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                                                                    <g clip-path="url(#clip0_11006_24214)">
                                                                        <path d="M12.25 8.75V11.0833C12.25 11.3928 12.1271 11.6895 11.9083 11.9083C11.6895 12.1271 11.3928 12.25 11.0833 12.25H2.91667C2.60725 12.25 2.3105 12.1271 2.09171 11.9083C1.87292 11.6895 1.75 11.3928 1.75 11.0833V8.75" stroke="#1E293B" stroke-width="1.54" stroke-linecap="round" stroke-linejoin="round" />
                                                                        <path d="M4.08423 5.83325L7.0009 8.74992L9.91756 5.83325" stroke="#1E293B" stroke-width="1.54" stroke-linecap="round" stroke-linejoin="round" />
                                                                        <path d="M7 8.75V1.75" stroke="#1E293B" stroke-width="1.54" stroke-linecap="round" stroke-linejoin="round" />
                                                                    </g>
                                                                    <defs>
                                                                        <clipPath id="clip0_11006_24214">
                                                                            <rect width="14" height="14" fill="white" />
                                                                        </clipPath>
                                                                    </defs>
                                                                </svg>
                                                            }>
                                                            Export
                                                        </Button>
                                                        :
                                                        paginationProcess === "backend" && exportBackendLoading ?
                                                            <Button
                                                                className="export_btn_d2"

                                                            >
                                                                <img
                                                                    src={FullLoader}
                                                                    alt="USP"
                                                                    height={15}
                                                                    width={15}
                                                                    className="loader_icon"
                                                                />

                                                                Export
                                                            </Button>
                                                            :
                                                            paginationProcess === "backend" && !exportBackendLoading ?
                                                                <Button
                                                                    className="export_btn_d2"
                                                                    onClick={() => { getDataViaBackend(dateRangePreviousApplied, dimensionsListPreviousApplied, metricsListPreviousApplied, filterRepeaterPreviousApplied, "", sortObject, 1) }}
                                                                    disabled={totalAdkRecords > 200000}
                                                                    style={{ pointerEvents: totalAdkRecords > 200000 ? "none" : "" }}
                                                                    icon={
                                                                        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                                                                            <g clip-path="url(#clip0_11006_24214)">
                                                                                <path d="M12.25 8.75V11.0833C12.25 11.3928 12.1271 11.6895 11.9083 11.9083C11.6895 12.1271 11.3928 12.25 11.0833 12.25H2.91667C2.60725 12.25 2.3105 12.1271 2.09171 11.9083C1.87292 11.6895 1.75 11.3928 1.75 11.0833V8.75" stroke="#1E293B" stroke-width="1.54" stroke-linecap="round" stroke-linejoin="round" />
                                                                                <path d="M4.08423 5.83325L7.0009 8.74992L9.91756 5.83325" stroke="#1E293B" stroke-width="1.54" stroke-linecap="round" stroke-linejoin="round" />
                                                                                <path d="M7 8.75V1.75" stroke="#1E293B" stroke-width="1.54" stroke-linecap="round" stroke-linejoin="round" />
                                                                            </g>
                                                                            <defs>
                                                                                <clipPath id="clip0_11006_24214">
                                                                                    <rect width="14" height="14" fill="white" />
                                                                                </clipPath>
                                                                            </defs>
                                                                        </svg>
                                                                    }>
                                                                    Export
                                                                </Button>
                                                                :

                                                                <Button
                                                                    className="export_btn_d2"
                                                                    onClick={() => { handleExport(exportHeader, exportData) }}
                                                                    icon={
                                                                        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                                                                            <g clip-path="url(#clip0_11006_24214)">
                                                                                <path d="M12.25 8.75V11.0833C12.25 11.3928 12.1271 11.6895 11.9083 11.9083C11.6895 12.1271 11.3928 12.25 11.0833 12.25H2.91667C2.60725 12.25 2.3105 12.1271 2.09171 11.9083C1.87292 11.6895 1.75 11.3928 1.75 11.0833V8.75" stroke="#1E293B" stroke-width="1.54" stroke-linecap="round" stroke-linejoin="round" />
                                                                                <path d="M4.08423 5.83325L7.0009 8.74992L9.91756 5.83325" stroke="#1E293B" stroke-width="1.54" stroke-linecap="round" stroke-linejoin="round" />
                                                                                <path d="M7 8.75V1.75" stroke="#1E293B" stroke-width="1.54" stroke-linecap="round" stroke-linejoin="round" />
                                                                            </g>
                                                                            <defs>
                                                                                <clipPath id="clip0_11006_24214">
                                                                                    <rect width="14" height="14" fill="white" />
                                                                                </clipPath>
                                                                            </defs>
                                                                        </svg>
                                                                    }>
                                                                    Export
                                                                </Button>
                                                    }
                                                </div>
                                            </>
                                        }
                                    </div>
                                </div>
                                <div className="table_content--box mb_20">
                                    {backendLoading && !initialLoad &&
                                        <div className="table_new_loader_d2">
                                            <img src={FullLoader} className="img-fluid" alt="" />
                                        </div>
                                    }

                                    {initialLoad ?
                                        <div className="bg-white p-2" style={{ borderRadius: '1.2rem' }}>
                                            <TableLoader />
                                        </  div>
                                        :

                                        <div className="reporting_table">

                                            <Table
                                                columns={columnsAll}
                                                pageSize={100}
                                                dataSource={data}
                                                onChange={handleTableChange}
                                                pagination={false}
                                                rowKey={(record) => record.id}
                                                locale={locale}
                                                scroll={{ x: data.length === 0 ? '1500' : 'max-content', y: 'calc(100vh - 27rem' }}
                                                showSorterTooltip={false}
                                                summary={() => (
                                                    data.length > 0 && search.trim().length === 0 ? (
                                                        <Table.Summary fixed >
                                                            <Table.Summary.Row className="test" >
                                                                {columnsAll?.flatMap(col => col.children ? col.children : [col])?.map((column, index) => (
                                                                    <Table.Summary.Cell key={column?.key}
                                                                        className={index === 0 ? "summary_total" : ""}
                                                                    >
                                                                        {index === 0 ? 'TOTAL' :
                                                                            Object.keys(total).length > 0 ?
                                                                                (total[column.key] !== undefined && total[column.key] !== null && total[column.key] !== "-" && total[column.key] !== "") ?
                                                                                    (column.key) === "pub_revenue" || (column.key) === "pub_total_cost" || (column.key) === "profit" || (column.key) === "pub_net_ecpm" || (column.key) === "pub_rpm" || (column.key) === "pub_avg_bidfloor" ?

                                                                                        <>$ {addCommasToNumber(total[column.key])}</> :

                                                                                        (column.key) === "pub_fill_rate" || (column.key) === "pub_coverage_rate" || (column.key) === "pub_win_rate" || (column.key) === "pub_ctr" || (column.key) === "givtImpsRate" || (column.key) === "sivtImpsRate" || (column.key) === "viewability" || (column.key) === "givtSivtRate" || (column.key) === "pub_new_coverage" ?

                                                                                            <>{addCommasToNumber(total[column.key])} %</> :

                                                                                            addCommasToNumber(total[column.key]) : "-" : "-"}
                                                                    </Table.Summary.Cell>
                                                                ))}
                                                            </Table.Summary.Row>
                                                        </Table.Summary>
                                                    ) : null
                                                )}
                                            />

                                        </div>


                                    }

                                    {data.length > 0 &&
                                        <Row className="custom_pagination--container" ref={tableScrollRef}>
                                            <Col span={6}>
                                                <div className="form_content_block--group mb_0">
                                                    <Select
                                                        className='form_select basic sm no_search'
                                                        value={page.pageSize}
                                                        onChange={handlePageSizeChange}
                                                        style={{ width: 80 }}
                                                        showSearch={false}
                                                        options={[
                                                            { value: 20, label: 20 },
                                                            { value: 50, label: 50 },
                                                            { value: 100, label: 100 },
                                                            { value: 500, label: 500 },
                                                        ]} />
                                                    <label className='custom_pagination--label'>
                                                        items per page
                                                    </label>
                                                </div>
                                            </Col>
                                            <Col span={6}>
                                                <span className="custom_pagination--total-text">
                                                    {`${(page.current - 1) * page.pageSize + 1}-${Math.min(page.current * page.pageSize, page.total)} of ${page.total} items`}
                                                </span>
                                            </Col>
                                            <Col span={6}>
                                                <Pagination
                                                    current={page.current}  // Pass individual props instead of spreading them
                                                    pageSize={page.pageSize}
                                                    total={page.total}
                                                    onChange={handlePageChange}
                                                    showSizeChanger={false}
                                                    itemRender={itemRender}
                                                    className="custom_pagination" />
                                            </Col>
                                        </Row>
                                    }
                                </div>

                            </>
                        }

                    </>
                    :
                    <div
                        style={{ width: "100%", height: "60vh" }}
                        className="d-flex justify-content-center align-items-center">
                        <img
                            src={FullLoader}
                            width={50}
                            height={50}
                            alt="" />
                    </div>
                }


            </div>

            <Modal className='custom_modal custom_modal_form_d2'
                title={
                    <div className='custom_modal--header'>
                        <div className="d_flex justify_content_between">

                            <h3 className='heading' >
                                <img src={uploadFileIcon} alt='USP' /> Save Configuration
                            </h3>
                        </div>
                    </div>
                }
                visible={isSaveConfigurationModalVisible}
                onCancel={closeSaveConfigurationModal}
                closable={true}
                maskClosable={false}
                width={770}
                footer={[
                    <div className="custom_modal--footer d_flex justify_content_between publisher_domain_upload_footer">
                        <div className="d_flex justify_content_start align_items_center"
                        // style={{ opacity: buttonProcessing ? "1" : "0" }}
                        >
                            {/* <img src={iconProcessingRequest} alt="" />
                                        <p >Processing request ...</p> */}
                        </div>
                        <div className="btn_group justify-content-end gap_8">
                            {configurationButtonProcessing ?
                                <>
                                    <button className="w_120_d2 btn btn_white_outline w_fit_content"
                                    >
                                        Discard
                                    </button>
                                    <button
                                        className="w_120_d2 btn btn_primary w_fit_content loader"

                                    >
                                        <span>Upload</span>

                                        <img
                                            src={loaderIcon}
                                            alt="USP"
                                            className="loader_icon"
                                        />
                                    </button>

                                </>
                                :
                                <>
                                    <button className="w_120_d2 btn btn_white_outline w_fit_content"
                                        onClick={closeSaveConfigurationModal}
                                    > Discard </button>
                                    <button className="w_120_d2 btn btn_primary w_fit_content"
                                        onClick={handleConfigurationDataSave}
                                    >Save</button>
                                </>
                            }
                        </div>
                    </div>
                ]}
            >
                <div className="custom_modal--body">
                    <div className="tab_content--body">
                        <div className="form_content_block--group modal_form_bottom_gap_d2 mb-0">
                            <label className="form_label">Configuration Name *</label>
                            <Input
                                type='text'
                                className='form_control basic'
                                placeholder="Name"
                                value={configurationName}
                                onChange={onChangeConfigurationName}
                                onBlur={onBlurConfigurationName}
                            />
                            <span className="error_content"> {configurationNameIsRequiredError && <>  This field is required</>}
                            </span>
                        </div>


                    </div>
                </div>
            </Modal>


        </>
    );
};

export default Reporting;
